import * as angular from 'angular';

import {
    fn, IInfOperation, INamed, CreateCounter, htmlEncode
} from '@common/utils';

import {
    IDialogState, DialogService
} from '@services/dialogservice';

import {
    IPageProperty, IPageQueryConstraint, IPageMetaData, IViewPageDisplay, DeferredObservable, IEvent, IDetermineDynamicLookupEvent
} from './nav';
import {
    NavItemAnchor, NavClientService, NavPageItem, NavPropertyItem, NavLineData, NavPropertyItems,
    NavPageItems, IPropertyInfoCallback, Observable
} from './navdata/navdata';
import * as rwf3 from '@common/rwf';

import { constants as kconstants, Bind as kBind, SaveAsExcel, NavItemsGrid } from '@common/navkendo';

import {
    IInfNotification, InfNotificationEntry
} from '@common/navkendo/infoma.kwidgets';
import { INavGrid } from '@common/navkendo/navgrid';
import { NavSettingsService, InfUserSettingsAccess } from '@common/services/settingsservice';

import {
    DisplayPage_Main, DisplayPage_Wizard, IKWFOperation,
    IKWFSessionState, DisplayPageItem
} from '@common/rwf/rwf.edit.d';

import { ShowModalReadMultipleSelect } from './navkendo/lookup/lookup';
import { CtrlKontierungsVorschlag } from './editform/kontierungsvorschlag/kontierungsvorschlag.ctrl';
import { CtrlHuelaufteilung } from './editform/huelaufteilung/huelaufteilung.ctr';
import { CtrlDeferralSchedule } from './editform/deferralschedule/deferralschedule.ctrl';
import { CtrlKWF3SupplementDocuments, SetCurrWFDocument } from './editform/supplementdocuments/supplementdocuments';
import { CtrlWKFOrderInformation } from './editform/orderinformation/orderinformation.ctr';
import { ShowMultiplyDialog } from './editform/multiplylines/multiplylines.ctr';
import {
    SessionEvents as _Events,
    PROP_Order_Line_No,
    PROP_LuGMAddRec, PROP_OrderNo, PROP_SumLines, SessionEvents
} from '@common/rwf/rwfedit.common';
import {
    FDDI_DMS_Purchase_Document, FDDI_DMS_Sales_Document,
    FDRW_Auftragsbuchblatt, FDRW_Anordnungsblatt, FDRW_Auftrag,
    FDRW_Wizard, FDDI_Wizard_Create_New_DMS_Document, METHOD, ROWMETHOD, PROP
} from '@common/rwf/rwf.const';
//#region Imports

import UISafe = fn.UISafe;
import resolveToError = fn.resolveToError;
import { CompatibilityService } from '@services/compatibilityservice';
import { IPagePropertyDependencyItem, IPageQueryResult, IViewProperty, IViewPropertyGroup } from '@common/navdata';
import { IsRechnungMitBestellbezug as isRechnungMitBestellbezug, IsPurchOrderChange as isPurchOrderChange, IsKameral, IsMainDocSignatureForced, IsPurchOrder, IsPurchOrderChange } from '@common/rwf/rwf.functions';
import { RWF3BaseService } from './editform/rwf3baseservice';
import { LugmEnsureLines, IRwfBootstrapParameters, IFDRW_Workflow_Instance_Action_List, ExecutePostingCheck, TWFInstanceID, IFDDI_DMS_Purchase_Document, IIAX_DMSPurch_DocumentLine, IFDDI_Wizard_Create_New_DMS_Document, IFDRW_WF_Instance_Subscriptions } from '@common/rwf';
import { EV_ExternalPreviewStateChangedError } from './PreviewDock';
import { CtrlPurchOrder } from './editform/pageitemview/purchorder.ctrl';
import { CtrlWizardItem } from './editform/pageitemview/wizarditem.ctrl';
import { IKWFRoutingAction, IKWFRoutingActions, IKWFComment, GetCurrentSubActionTitle } from '@common/rwf/routeinstancemodel';
import { Subscription } from 'rxjs';
import { INavPageItemEditOptions } from '@common/navkendo/navpageitems';
import { ShowFAPartDispose } from '@rwfangularjs/editform/fapartdispose/fapartdispose.ctrl';
import { AdjustGlobalProperties } from './navkendo';
import { IsATAO } from '@common/rwf/rwfpages.generated.addon';
import { CtrWFInstanceAddOnData } from './CtrWFInstanceAddOnData';

const PROP_AddRecLuGMEntryNo = PROP.AddRecLuGMEntryNo;
const PROP_Entry_No = PROP.Entry_No;


//#endregion

//#endregion

/** Open currently Open readonly Form wOut Readonly */
export function OpenReadonlyFormForEdit() {
    window.setTimeout(() => {
        var injector: ng.auto.IInjectorService = angular.element($(window.document.documentElement)).injector(),
            location = injector.get<ng.ILocationService>("$location"),
            search = location.search();
        if (search.readonly) {
            location.search("readonly", "0");
            injector.get<ng.IRootScopeService>("$rootScope").$apply();
        }
    });
    return false;
}

/** Helper Error for marking explicit Cancel Operation */
const __confirmError = fn.error.ExplicitError("Cancelled", true);
const Reservation = "Reservation";
const PurchOrderChange = "PurchOrderChange";
interface ICustomPropertyDependency {
    Dependencies: Array<IPagePropertyDependencyItem<any, any, KWFFormSession>>;
    CustomReadonly?: IPropertyInfoCallback;
    CustomMandatory?: IPropertyInfoCallback;
}

const sourceValueEquals = (constValue: string | string[]) => {
    if (Array.isArray(constValue)) {
        return (p: NavPageItem, value: any) => constValue.indexOf(value) >= 0;
    } else {
        return (p: NavPageItem, value: any) => value === constValue;
    }
};
// TODO  : Line Properties Visible, + Dynamic Captions!
/** Configuration of Property Dependencies (Enabled, Mandatory) per Page */
var _PropertyDependencies: Partial<Record<DisplayPage_Main, ICustomPropertyDependency>> = {
    FDDI_DMS_Sales_Document: {
        Dependencies: [
            {
                SourcePath: "SalesLines.Type",
                DestProperties: ["No"],
                Enabled: (item, v) => v !== "" && v !== "_blank_"
            },
            // - Ausgleich mit Belegart/Belegnummer : machen nur gemeinsam Sinn
            {
                SourcePath: "Applies_to_Doc_Type",
                DestProperties: ["Applies_to_Doc_No"],
                Mandatory: (item: rwf3.FDDI_DMS_Sales_Document, docType) => (docType != "_blank_")
            },
            {
                SourcePath: "Applies_to_Doc_No",
                DestProperties: ["Applies_to_Doc_Type"],
                Mandatory: (item: rwf3.FDDI_DMS_Sales_Document, docNo) => !!docNo
            },
        ],
    },
    FDDI_Wizard_Create_New_DMS_Document: {
        Dependencies: [
            /** Kontierungsvorlage (Allocation_Template) aktiv nur für "Beleg erstellen aus" (Creation_Type) == "Allocation_Template"  */
            {
                SourcePath: "Creation_Type",
                DestProperties: ["Allocation_Template"],
                Enabled: sourceValueEquals("Allocation_Template"),
                Mandatory: sourceValueEquals("Allocation_Template")
            },
            /** Bestellnummer nur aktiv und dann pflichtig, falls "Beleg erstellen aus" ("Creation_Type") == "Order_No" */
            {
                SourcePath: "Creation_Type",
                DestProperties: ["Order_No"],
                Enabled: sourceValueEquals(["Order_No", PurchOrderChange]),
                Mandatory: sourceValueEquals(["Order_No", PurchOrderChange])
            },
            /** Im Bestellfall aus der Bestellung übernommen, deaktivieren auf Wizard */
            {
                SourcePath: "Creation_Type",
                DestProperties: ["Gemeindenr", "Responsibility_Center"],
                Enabled: (item, cType) => cType !== "Order_No"
            },
            /** Im Bestellfall  aus der Bestellung übernommen, deaktivieren auf Wizard, ausser : 'mit Abstimmsumme' (US70487) */
            <IPagePropertyDependencyItem<any, rwf3.IFDRW_Workflow_Setup_WS, KWFFormSession>>{
                InitContext: s => s.Anchor.Service.$c.resolve("Rwf")("RwfAppSettings").RwfBootstrap.EnsureResolved().RwfSetup,
                SourcePath: "Creation_Type",
                DestProperties: ["Amount_incl_VAT"],
                Enabled: (item, cType, ctx) => {
                    if (ctx && ctx.ReconciliationTotalEnabled == true) {
                        // Absitmmsumme aktiv-> nicht einmischen ...
                        return null;
                    }

                    return cType !== "Order_No";
                }
            },
            /** Im Mittelreservierungsfall wird die externe Belegnummer nicht benötigt -> deaktivieren auf Wizard */
            {
                SourcePath: "Creation_Type",
                DestProperties: ["External_Document_No"],
                Enabled: (item, cType) => cType !== Reservation
            },
            /** "Beleg erstellen aus" = "Wiederkehrender Beleg" --> Wieerkehrende Belegnummer*/
            {
                SourcePath: "Creation_Type",
                DestProperties: ["RecurringDocumentNo"],
                Mandatory: sourceValueEquals("RecurringDocument"),
                Enabled: sourceValueEquals("RecurringDocument")
            }
        ],

        CustomMandatory: config => {
            // TODO See Readonly above:
            // TODO shouldn't we auto disable all mandatory logic for disabled fields?
            var Creation_Type = config.Item.MetaData.PropsByName["Creation_Type"];
            const depProps = ["Gemeindenr", "Responsibility_Center"].map(fld => config.Item.MetaData.PropsByName[fld]);
            var cType = config.Item.GetValueEx(Creation_Type);
            config.Item.RegisterPropertyChanged(Creation_Type, () => {
                cType = config.Item.GetValueEx(Creation_Type);
                if (cType == "Order_No") {
                    depProps.forEach(item => config.ExplicitState[item.Name] = false);
                } else {
                    depProps.forEach(item => delete config.ExplicitState[item.Name]);
                }
                depProps.forEach(item => config.Container.fireChange(item));
            });
            if (cType == "Order_No") {
                depProps.forEach(item => config.ExplicitState[item.Name] = false);
            }
        }
    },
    FDDI_DMS_Purchase_Document: {
        // #region Dependencies
        Dependencies: [
            {
                // Vendor_Cr_Memo_No : only Visible if Gutschrift
                SourcePath: "Document_Type",
                DestProperties: ["Vendor_Cr_Memo_No"],
                Visible: sourceValueEquals("Credit_Memo")
            },
            { // Vendor_Invoice_No macht auf Bestellungen und Gutschriften keinen Sinn!
                // Vendor_Invoice_No : only Visible if NOT Gutschrift AND Bestellung
                SourcePath: "Document_Type",
                DestProperties: ["Vendor_Invoice_No"],
                Visible: (item, docType) => (docType != "Credit_Memo") && (docType != "Order")
            },
            <IPagePropertyDependencyItem<any, KWFFormSession, KWFFormSession>>{
                InitContext: fn.identity,
                //Buy_from_Vendor_No deaktivieren falls Wizard.Creation_Type RecurringDocument, Order_No oder PurchOrderChange
                SourcePath: "Document_Type", // Dummy
                DestProperties: ["Buy_from_Vendor_No"],
                Enabled: (item, value, session : KWFFormSession) =>
                {
                    const wzrdItem = session?.KWFService?.WizardItem as NavPageItem<IFDDI_Wizard_Create_New_DMS_Document>;
                    const document_type = wzrdItem?.GetValue("Creation_Type")
                    //  Creation_Type: /**blank*/0 |/**Allocation_Template*/1 |/**Order_No*/2 |/**Reservation*/3 |/**RecurringDocument*/4 |/**PurchOrderChange*/5;
                    return [2, 4, 5].indexOf(document_type) < 0; // WI-116636
                }
            },
            {
                // Zahlungsart, .., nur sichbar für Bestellung
                SourcePath: "OrderNo",
                DestProperties: ["Zahlungsart"],
                Visible: (item, orderNo) => isRechnungMitBestellbezug(item) || IsPurchOrder(item) || IsPurchOrderChange(item),
            },
            {
                // Bestellnummer, .., nur sichbar wenn gefüllt
                SourcePath: "OrderNo",
                DestProperties: ["OrderNo"],
                Visible: (item, orderNo) => !!orderNo,
            },
            {
                // Kopfelder "Betrag inkl. MWST", "Nummer", "Responsibility_Center" für "Rechnung mit Bestellbezug" nicht editierbar
                SourcePath: "OrderNo",
                DestProperties: ["Prices_Including_VAT", "Buy_from_Vendor_No", "Responsibility_Center"],
                Enabled: (item, orderNo) => !isRechnungMitBestellbezug(item) // Document_Type == Invoice // 136724
            },
            // - Ausgleich mit Belegart/Belegnummer : machen nur gemeinsam Sinn
            {
                SourcePath: "Applies_to_Doc_Type",
                DestProperties: ["Applies_to_Doc_No"],
                Mandatory: (item: rwf3.FDDI_DMS_Purchase_Document, docType) => (docType != "_blank_")
            },
            {
                SourcePath: "Applies_to_Doc_No",
                DestProperties: ["Applies_to_Doc_Type"],
                Mandatory: (item: rwf3.FDDI_DMS_Purchase_Document, docNo) => !!docNo
            },
            // RWFPaymentDiscountAmount, Payment_Discount_Percent keep in Sync
            {
                SourcePath: "Payment_Discount_Percent",
                DestProperties: ["RWFPaymentDiscountAmount", "Payment_Discount_Percent"],
                Enabled: (item) => {
                    return !item.Root.Anchor.Readonly.GetValue("Payment_Discount_Percent", item);
                }
            }
        ],

        /**  CustomReadonly state for "Bestellbezug"*/
        CustomReadonly: (config) => {
            const item = config && config.Item,
                rootItem = item?.Root,
                isOrderDocument = isRechnungMitBestellbezug(rootItem),
                metaData = item && item.MetaData;

            if (!item) {
                return;
            }

            if (isPurchOrderChange(rootItem) && metaData.PropertyName == "PurchLines") {
                // Falls Hier : wir sind im Bestelländerungsfall (Zeile)
                // nur folgende Felder sind edititerbar ( + explizit entsperrte Felder, aber nur as 'validNames')
                DisableLineSplitPropsChange();
                return;
            }

            if (!isOrderDocument)
                return;

            let explicitUnlocked = item.Root.Anchor.Readonly.ExplicitUnlocked;

            if (!metaData.PropertyName) {
                // Kopf
                let lockHeaderProps = ["Gemeindenr", "Shortcut_Dimension_1_Code", "Shortcut_Dimension_2_Code", "VAT_Bus_Posting_Group"];
                if (explicitUnlocked && explicitUnlocked.length > 0) {
                    lockHeaderProps = lockHeaderProps.filter(p => explicitUnlocked.every(item => item.Path != p));
                }

                lockHeaderProps.forEach(n => config.ExplicitState[n] = true);
            }
            else if (metaData.PropertyName == "PurchLines") {
                // Zeile
                var isLineOrder = !!item.GetValue(PROP_Order_Line_No);

                if (isLineOrder) {
                    // Falls Hier : wir sind im Bestellfall : Zeile mit Bestellbezug
                    // nur folgende Felder sind edititerbar ( + explizit entsperrte Felder, aber nur as 'validNames')
                    let allowedUnlockedNames = ["PurchLines.Shortcut_Dimension_1_Code", "PurchLines.Shortcut_Dimension_2_Code"],
                        validNames = ["PurchLines.Description", "PurchLines.Description_2", "PurchLines.Direct_Unit_Cost",
                            "PurchLines.Vorgangsnummer", "PurchLines.FA_Posting_Date", "PurchLines.Quantity", "PurchLines.FA_Quantity",
                            ...((item.Root.Anchor.Readonly.ExplicitUnlocked || []).filter(item => allowedUnlockedNames.indexOf(item.Path) >= 0)).map(item => item.Path)];

                    let purchProps = item.MetaData.Properties.map(item => item.Path);
                    var readonlyProps = purchProps.filter(name => validNames.indexOf(name) < 0);
                    readonlyProps.forEach(p => config.ExplicitState[p] = true);
                } else if (isOrderDocument && !isLineOrder) {
                    DisableLineSplitPropsChange()
                }
            } else if (metaData.PropertyName === PROP_LuGMAddRec) {
                let purchItems = item.Root.GetLineData("PurchLines");
                let lugmEntryNo = item.GetValue("Entry_No");
                let mainItem = purchItems && lugmEntryNo && purchItems.Items.filter(item => item.GetValue(PROP_AddRecLuGMEntryNo) == lugmEntryNo)[0];
                var isLineOrder = mainItem && !!mainItem.GetValue(PROP_Order_Line_No);
                if (isLineOrder && isOrderDocument) {
                    // lugm Zeile nicht editierbar für Bestellbezug!
                    let validNames = new Array<string>();
                    let lugmProps = item.MetaData.Properties.map(item => item.Path);
                    var readonlyProps = lugmProps.filter(name => validNames.indexOf(name) < 0);
                    readonlyProps.forEach(p => config.ExplicitState[p] = true);
                }
            }

            function DisableLineSplitPropsChange(this: void) {
                const invalidNames = ["PurchLines.CommNo", "PurchLines.PDate", "PurchLines.DDate", "PurchLines.LDate"];
                const purchProps = item.MetaData.Properties.map(item => item.Path);
                const readonlyProps = purchProps.filter(name => invalidNames.indexOf(name) >= 0);
                readonlyProps.forEach(p => config.ExplicitState[p] = true);
            }
        },

        CustomMandatory: (config) => {
            var item = config && config.Item;

            // ZahlungsArt macht nur Im Bestellfall Sinn (wird sonat auch ausgeblendet.)
            if (item && !item.MetaData.PropertyName && !isRechnungMitBestellbezug(item as DisplayPageItem)) {
                config.ExplicitState["Zahlungsart"] = false;
            }

            function IsPurchLine(item : NavPropertyItem) : item is NavPropertyItem<IIAX_DMSPurch_DocumentLine> {
                return item?.MetaData?.PropertyName == "PurchLines"
            }
            if (!IsPurchLine(item))
                return;

            // Zeile!
            if (item.GetValue(PROP_Order_Line_No) && isRechnungMitBestellbezug(item.Root))
            {
                const LineMetaData = item.MetaData;
                const LineProperties = LineMetaData.Properties;
                const ExplicitState = config.ExplicitState;
                const Unit_Cost_LCY = LineMetaData.PropsByName["Unit_Cost_LCY"];
                const PropertyContainer = config.Container;

                if (item.GetValue(Unit_Cost_LCY) == 0) {
                    // Für Bestellzeilen ohne gefüllten Betrag : alle Pflichtfelder ignorieren
                    LineProperties.forEach(p => config.ExplicitState[p.Path] = false);
                }

                // react on value change ...
                item.RegisterPropertyChanged(Unit_Cost_LCY, () => {
                    if (item.GetValue(Unit_Cost_LCY) == 0) {
                        LineProperties.forEach(p => ExplicitState[p.Path] = false);
                    } else {
                        LineProperties.forEach(p => delete ExplicitState[p.Path]);
                    }

                    LineProperties.forEach(item => PropertyContainer.fireChange(item));
                });
            }
        }
        // #endregion
    },
    FDRW_Wizard:
    {
        Dependencies: [
            /** Auftragsnr (Auftragsnr) aktiv nur für "Beleg erstellen aus" (EinnahmeAusgabe) == "Auftragsnr"  */
            {
                SourcePath: "EinnahmeAusgabe",
                DestProperties: ["Auftragsnr"],
                Enabled: (item, cType) => cType === "Auftrag",
                Mandatory: (item, cType) => cType === "Auftrag"
            },
            /** Kassenzeichen,Buchungsdatum (External_Document_No,Posting_Date) nicht aktiv für "Beleg erstellen aus" (EinnahmeAusgabe)  "Reservierung"  */
            {
                SourcePath: "EinnahmeAusgabe",
                DestProperties: ["External_Document_No", "Posting_Date"],
                Enabled: (item, cType) => cType !== "Reservierung"
            }
        ],
    }
};

//#endregion

namespace util {
    /** Focus first Input in Selector */
    export function focus(sel: JQuery) {

        // ensure Dock Zone split area is not collapsed
        sel.parents(":data('kendoSortable')").each((idx, elSort: HTMLElement) => {
            var dockZones = $(elSort).parent().data("kendoNavPageitemDockZones");
            if (dockZones) {
                dockZones.expand(elSort);
            }
        });
        // ensure uncollapsed state of DockItem/ Collapsibles
        sel.parents(":data(kendoMobileNavCollapsible)").each((idx, elSort) =>
            $(elSort).data("kendoMobileNavCollapsible").expand(false));
        sel.parents(":data('kendoNavDock')").each((idx, el) =>
            $(el).data("kendoNavDock").Expand(false));

        // Caution : Dialog spoils the Focus - Operation [Handled in Basic Operation ShowDialog ...] !
        $(':input:enabled:first', sel.parent()).focus();
    }

    /** focus by propertyValue */
    export function focusProp(item: NavPropertyItem, prop: IPageProperty) {
        var propName = prop && prop.Name,
            parentProp = prop && prop.ParentProp;
        if (parentProp) {
            // ParentProp : It's displayed in a grid
            var gridEl = $("[navPropertyName=" + parentProp.Name + "]");
            focus(gridEl);
            var grid = gridEl.data("kendoNavGrid");
            if (grid) {
                var id = item.Model.uid;
                grid.editCellById(id, propName);
            }
        } else {
            focus($("[navPropertyName=" + propName + "]").first());
        }
    }

    /** try  resolve ErrorMessage to User Readable ...*/
    export function errResolve(err: any) {
        var result = <string>resolveToError(err, false);
        if (typeof result == "string")
            return replaceModified(result).message;
        return result;
    }

    /** Replace NAV 'Other User has modfied .....' with user friendly message */
    function replaceModified(message: string) {
        message = "" + message;
        var match = message.match(modifiedRegEx),
            pageName = (match && match[1]) || "",
            result = {
                message: message.replace(modifiedRegEx, "Die Daten für '" + pageName + "' wurden von einem anderen Benutzer geändert"),
                page: pageName,
                toString: () => result.message,
                origMessage: message
            };
        return result;
    }
    var modifiedRegEx = /Other user has modified \"([^\"]+)\" \"[^\"]+\"/;
}

/** KWF Edit Session */
export class KWFFormSession extends DeferredObservable(Observable) {

    /** Pending Session to Open in Next Cycle */
    public static PendingOpen?: KWFFormSession;

    /** Instantiate a KWF Edit Form Session from Configuration and Current Route Parameters => PromiseLike<KWFEditForm.KWFFormSession> */
    public static Instantiate(this: void, $c: CompatibilityService, instanceId: TWFInstanceID, isReadonly: boolean): PromiseLike<KWFFormSession> {
        var created: KWFFormSession;
        /** to Discuss: do we handle this scenario? */
        const ForcedSingleOpen = true;

        const dlg = $c.resolve("DialogService");
        const NavSettings = $c.resolve("NavSettings");
        const KWFApplication = $c.resolve("Rwf")("RwfApplication");
        const $RwfBootstrap = $c.resolve("Rwf")("RwfBootstrap");
        if (created = KWFFormSession.PendingOpen) {
            // Handling MassOpen scenario ... Unify ForcedOpen Handling Open/Close/
            delete KWFFormSession.PendingOpen;
            createSession = $c.when(created);
        } else {
            // Create Session from parameters
            var createSession = $RwfBootstrap.Resolve.then($rwf => {
                if (instanceId) {
                    return RWF3BaseService.Create($c, instanceId, $rwf.NavUrlInfo);
                } else {
                    throw new Error("Ungültiger Aufruf: fehlender Parameter 'instanceId'");
                }
            }).then(service => service.AttachSession(new KWFFormSession($c, service), !isReadonly));
        }
        return createSession.then(session => {
            var navUrl = session.DisplayItem && session.DisplayItem.ClientInfo.Url;
            let id = session.ID;
            if (navUrl && session.KWFService.IsCheckedOut) {
                // SetUp Notification of Open/Close to other Users
                let result = KWFApplication.NotifyEditChange([{ InstanceId: id, Action: "Open" }], navUrl),
                    onDestroy = fn.nullOp,
                    openInfo: { ConnectionId: string };
                session.one(SessionEvents.destroyed, () => {
                    (onDestroy || fn.nullOp)();
                    session = undefined;
                    KWFApplication.NotifyEditChange([{ InstanceId: id, Action: "Close" }], navUrl);
                });
                return result.then((info) => {
                    openInfo = info && info.Opened && info.Opened[0];
                    onDestroy = NavSettings.RegisterOnUnload(() => {
                        // in Unload we must send sync Notification to ensure correctness ...
                        var connectionId = openInfo.ConnectionId;
                        if (connectionId) {
                            var req = new XMLHttpRequest();
                            req.open("POST", "./infoma.Web.KWFHub/CloseEdit?" + fn.EncodeQueryData({ connectionId: connectionId }), false); // false
                            req.send();
                        }
                    });
                    if (info && info.AlreadyOpen && info.AlreadyOpen.length) {
                        var askUser = $c.when(true);
                        if (ForcedSingleOpen) {
                            askUser = dlg.ShowConfirm("Das Formular scheint aktuell bereits von Ihnen geöffnet zu sein.\n" +
                                "Wenn Sie das Formular jetzt öffnen wird eine evtl. vorhandene geöffnete Ansicht automatisch geschlossen!\n Wirklich öffnen?");
                        }
                        return askUser.then(answer => {
                            if (answer) {
                                // Trotzdem öffnen, vorher über Serverkommunikation andere(s) Formular(e) notifizieren/schliessen
                                return KWFApplication.NotifyForcedOpen(id).then(fn.nullOp, fn.nullOp);
                            } else {
                                throw fn.error.ThrowCancel();
                            }
                        }).then(() => session);
                    }
                    return session;
                }, err => {
                    return session;
                });
            }
            return session;
        }).then((session) => {
            const signalR = KWFApplication.RwfSignalRService;

            let unsub: Subscription;
            // Setup Forced Close on other (Forced) Open operation
            let onForcedOpen = (instanceId: string) => {
                if (session && instanceId && !session.IsDestroyed && ForcedSingleOpen && (instanceId == session.ID)) {
                    unsub.unsubscribe();
                    session.EnqueueOperation(() => {
                        const destroySession = () => session.destroy();
                        return dlg.ShowError("Sie haben das Formular erneut geöffnet. Diese Ansicht wird geschlossen!").then(destroySession, destroySession);
                    });
                }
            };

            // React on Notification:  Currently Displayed Instance got opened in another Window (from same user only)
            unsub = signalR.Register("onForcedOpen", onForcedOpen);
            session.bind(SessionEvents.destroy, () => unsub.unsubscribe());

            // Setup Reaction on External Change Notification
            let onExternalChange = (e: { InstanceId: string }) => {
                if (session.IsDestroyed || e.InstanceId !== session.ID)
                    return;

                KWFApplication.unbind("EditInstanceChanged", onExternalChange);
                session.EnqueueOperation(() => {
                    var clear = session.AddNotification({ message: "Das Formular wurde in newsystem geändert und wurde deshalb neu geladen", messageType: "info", group: "editChangeNav" });
                    // Clear Notification on Chage of display Item
                    session.one(SessionEvents.displaychange, clear);
                    const doRebind = () => KWFApplication.bind("EditInstanceChanged", onExternalChange);
                    return session.KWFService.RevertDisplay().then(doRebind, doRebind);
                });
            };
            KWFApplication.bind("EditInstanceChanged", onExternalChange);
            session.bind(SessionEvents.destroy, () => KWFApplication.unbind("EditInstanceChanged", onExternalChange));

            return session;
        });
    }

    private readonly NavClient: NavClientService;
    public readonly DialogService: DialogService;
    private readonly NavSettings: NavSettingsService;
    /** Global (not per Page!)  user settings */
    public readonly UserSettings: InfUserSettingsAccess;

    /** No Edit on Content Allowed (REadonlyView, etc, ...) */
    public get NoEdit() {
        if (this.CurrentState && (this.CurrentState.NoEditContent || this.CurrentState.CurrentStepReadOnly))
            return true;

        if (this.CustomState && this.CustomState.NoEditContent)
            return true;
    }
    /** PageName for Wizard */
    public readonly WizardPagename: DisplayPage_Wizard;

    public readonly $rwf: IRwfBootstrapParameters;
    constructor(private readonly $c: CompatibilityService, public readonly KWFService: RWF3BaseService) {
        super();
        const me = this;
        SetupCustomTextSelection.call(this);
        const $rwfResolve = $c.resolve("Rwf");
        const $rwf = this.$rwf = $rwfResolve("RwfBootstrap").EnsureResolved();
        const IsStandaloneUser = $rwf.RwfSettings.User.IsStandalone;
        if (IsStandaloneUser) {
            AdjustGlobalProperties({ IgnoreMissing: true });
        }
        const KWFOperations = this.KWFOperations;
        const NavClient = this.NavClient = $c.resolve("NavClient");
        const DialogService = this.DialogService = $c.resolve("DialogService");
        const NavSettings = this.NavSettings = $c.resolve("NavSettings");
        const FormSettings = $rwfResolve("RwfAppSettings").Get().then(s => s.FormSettings);
        var WizardPagename = this.WizardPagename = KWFService.WizardPagename;
        this.UserSettings = NavSettings.CreateUserSettings(["KWF", "KWFEditForm"]);

        // MSQQQ
        const rootScope = angular.element(window.document.documentElement).scope();
        if (rootScope) {
            this.one(_Events.destroy, rootScope.$on(EV_ExternalPreviewStateChangedError, (e) => {
                this.AddNotification({
                    message: "Ihr Browser verhindert das Öffnen der Dokumentvorschau in einem separaten Fenster. Überprüfen Sie die Pop-up-Blocker- Einstellungen.", messageType: "warning",
                    identifier: "Popupwarning"
                });
                e.preventDefault();
            }));
        }

        //#region setup Notification (collect until rendered, then display )
        type InitialInfNotificationEntry = InfNotificationEntry & { __Remove?: () => void };
        const notifications = new Array<InitialInfNotificationEntry>();
        const removeInitialNotification = (e: InitialInfNotificationEntry) => {
            if (notifications.length > 0) {
                const idx = notifications.indexOf(e);
                if (idx >= 0) {
                    notifications.splice(idx, 1);
                }
            } else if (e.__Remove) {
                e.__Remove();
            }
        };
        this.AddNotification = (e) => {
            notifications.push(e);
            return () => removeInitialNotification(e);
        };
        this.one(_Events.rendered, (e: { element: JQuery }) => {
            var scope = angular.element(e && e.element).scope();
            var notification = scope && <IInfNotification>scope["editFormNotificationBar"];
            if (notification) {
                this.AddNotification = notification.AddNotification.bind(notification);
                this.bind(SessionEvents.destroy, () => {
                    notification.RemoveNotifications();
                });
            } else {
                this.AddNotification = (e) => {
                    DialogService.ShowError(e.message);
                    return fn.noop;
                };
            }
            // show collected notifications
            notifications.forEach(n => n.__Remove = this.AddNotification(n));
            notifications.length = 0;
        });

        //#endregion

        // SetUp Notification Functionality for Register Display Change
        this.RegisterDisplayChange = (cb: Function) => kBind(this, cb, _Events.displaychange);
        this.bind(_Events.destroyed, () => this.RegisterDisplayChange = fn.ToFunc(fn.noop));
        this.Rendered = fn.proxy(this._Rendered, this);
        this.bind(_Events.destroyed, () => this.Rendered = fn.noop);
        //#region Setup Actions
        /** List of All Registered Operations */
        var allOperations = new Array<IKWFOperation>();

        var createOperation = fn.proxy(<T>(name: string, op: IKWFOperation & T) => {
            fn.validate(name && (typeof name == "string"), "Invalid Action Name");
            fn.validate(!this.KWFOperations[name], "Action '" + name + "' already defined");
            op.name = name;
            allOperations.push(this.KWFOperations[name] = op);
            return op;
        }, this);

        //#region SetUp Enforced Input Validation
        // Marker : "Aufforderung zur Mittelprüfung durchgeführt"
        var fundsChecked = false;
        this.bind(_Events.displaychange, () => fundsChecked = false);

        /** return rejection Promise if mandatory fields condition on input not met, undefined otherwise */
        var rejectOnMandatoryFields = (wizardOnlyFields = false) => {
            // Ensure Mandatory Fields on Displayed Item
            var wizrdOnlyItems = wizardOnlyFields && this.KWFService.CurrentWizardOnlyFields;
            let invalid = this.Anchor && this.Anchor.FindFirstInvalid(this.DisplayItem, (item, prop) => {
                if (wizardOnlyFields && wizrdOnlyItems) {
                    return wizrdOnlyItems.indexOf(prop.Path) >= 0;
                } else
                    return true;
            });
            if (invalid) {
                let prop = invalid.Prop,
                    invalidRoot = invalid.Item.Root;
                let doFocusAndReject = () => {
                    util.focusProp(invalid.Item, invalid.Prop);
                    return $c.reject("Bitte füllen Sie alle Pflichtfelder des Formulars aus!\nDas " +
                        (prop.ParentProp ? "Zeilenfeld" : "Feld") +
                        " '" + prop.Title + "' muss gefüllt werden.");
                };
                if (invalidRoot !== this.DisplayItem) {
                    // Defer after full 'visual' Navigation to Failed Item
                    return this.SetCurrentDisplayItem(invalidRoot, this.DisplayView).then(() => {
                        var defer = $c.defer(),
                            resolve = () => defer.resolve();
                        this.one(_Events.rendered, resolve); // Will Ensure continuation only after new UI representation available ...
                        this.$c.timeout(4000).then(resolve); // Ensure Continuation on Failure ....
                        return defer.promise;
                    }).then(doFocusAndReject, doFocusAndReject);
                } else
                    return doFocusAndReject();
            }
        };

        var ensureMandatoryActions = (mandatoryAction: rwf3.IFDRW_Workflow_Instance_Action_List) => {
            if (!mandatoryAction)
                return $c.when(undefined);
            var result = $c.when<any>(undefined);

            // Signature Mandatory handled in Routing!

            if (mandatoryAction.LeaveWizardRequired && this.DisplayPageName == WizardPagename && !IsMainDocSignatureForced(this.$rwf.RwfSetup, this.validatedRoutingAction)) {
                const msgLeaveWizardRequired = 'Der Beleg darf nicht aus der Vorerfassungsmaske weitergeleitet werden!';
                if (actLeaveWizard.Enabled) {
                    return result = DialogService.ShowConfirm(msgLeaveWizardRequired +
                        '\r\n Bitte führen Sie hierzu die Funktion \'Weiter zur Kontierung\' aus. \r\nSoll diese jetzt ausgeführt werden?'
                    ).then(answer => $c.when(answer && actLeaveWizard.Execute()).then(() => fn.error.ThrowCancel()));
                } else {
                    return result = $c.reject(msgLeaveWizardRequired);
                }
            }

            if (mandatoryAction.PostingCheckRequired && actPostingCheck.Enabled) {
                result = result.then(() => this.ExecutePostingCheck({ get mainGrid() { return mainGrid; }, supressSucessError: true }));
            }

            // Abstimmsumme Pflichtig
            if (!this.IsFWF && mandatoryAction.ReconciliationTotalRequired && DisplayItem && DisplayItem.ClientInfo.AllMethods["CheckReconciliationTotal"]) {
                result = result.then(() => {
                    return DisplayItem.ExecuteMethod({ MethodName: "CheckReconciliationTotal" }, undefined, true);
                });
            }

            if (mandatoryAction.RemarkMandatory && !this.CurrentRemark) {
                result = $c.reject("Eine Bemerkung ist notwendig!");
                $c.finally(result, () => util.focus($(".idms_kwfRemark", document)));
                return result;
            }

            let sForwardComment = this.SelectedForwardingComment;
            if (mandatoryAction.FWDCommentMandatory && !(sForwardComment && sForwardComment.ID)) {
                result = $c.reject("Ein Weiterleitungskommentar ist notwendig!");
                $c.finally(result, () => util.focus($(".idms_kwfComment", document)));
                return result;
            }

            // Ensure Mandatory Fields on Displayed Item
            var rejectMandatory: PromiseLike<any>;
            if (rejectMandatory = rejectOnMandatoryFields())
                return rejectMandatory;

            if (mandatoryAction.CheckFunds && !fundsChecked) {
                result = result.then(() =>
                    DialogService.ShowDialog({
                        title: "Aufforderung zur Mittelprüfung",
                        message: "Bitte führen sie eine Mittelprüfung durch und starten sie die Aktion dann erneut."
                    }).then(() => { fundsChecked = true; throw __confirmError; }));
            }

            if (mandatoryAction.Reauthenticate)
                result = result.then(() => KWFService.ReAuthenticate());

            if (mandatoryAction.ReserveFunds && !fundsReserved && actReserveFunding.Enabled) {
                result = result.then(() => actReserveFunding.Execute());
            }

            return result;
        };

        var validateInput = () => this.EnsureCommit().then(() => ensureMandatoryActions(this.MandatoryActions));
        // for these Commands Input Must be valid, including all Mandatory Actions Config!
        this.bindWithDefer(validateInput, "Route", "Sign");
        // for LeavWizard input must be valid
        this.bindWithDefer(() => rejectOnMandatoryFields(true), "LeaveWizard");

        //#endregion

        const WFInstance = this.KWFService.WFInstance;
        if (WFInstance && !IsStandaloneUser) {
            // Grid Display for AddonData if available (exclude swu for now, as external data not yet persisted for swu)
            const ctrlAddonData = new CtrWFInstanceAddOnData(this.$c, WFInstance.ClientInfo.Url, WFInstance.Model.ID, this.UserSettings);
            this.bind(_Events.destroy, () => ctrlAddonData.destroy());
            // "new" dynamic case:
            // so far: Refresh on Wizard if OrderNo Changed
            const refreshAddonData = () => ctrlAddonData.RefreshData(WFInstance.Model.ID, true);
            const onDisplayItemChange = () => {
                const CurrAddOnSource = this.DisplayItem as DisplayPageItem
                refreshAddonData();
                switch (CurrAddOnSource?.PageName) {
                    case "FDDI_Wizard_Create_New_DMS_Document":
                        this.RegisterDisplayChange(CurrAddOnSource.RegisterPropertyChanged("Order_No", refreshAddonData));
                        break;
                }
            }
            this.RegisterDisplayChange(onDisplayItemChange);
            onDisplayItemChange();
            this["AddonData"] = ctrlAddonData;
          }

        //#region defined Actions

        /** Weiterleiten */
        var actRoute = createOperation("Route", {
            Title: "Weiterleiten",
            Icon: "rwf-route",
            Enabled: false,
            Hidden: false,
            EnforceCommit: true,
            Execute: () => this.Route()
        });
        /** Aktion(en) wählen : "Dummy Aktion" für Enabling/Disabling  */
        var actSelectRoutingAction = createOperation("SelectRouting", { Enabled: true, Hidden: false, EnforceCommit: false, Execute: () => this.$c.reject("...") });
        var actSelectSubRoutingAction = createOperation("SelectSubRouting", { Enabled: true, Hidden: false, EnforceCommit: false, Execute: () => this.$c.reject("...") });
        /** Signieren */
        var actSign = createOperation("Sign", { Enabled: false, Hidden: "Enabled", EnforceCommit: true, Execute: () => this.Route() });
        /** Zwischenspeichern */
        var actSaveTemp = createOperation("SaveTemp", { Title: 'Zwischenspeichern', Icon: 'rwf-savetemp', EnforceCommit: true, Execute: () => this.Close(true) });
        FormSettings.then(s => { if (s?.SaveTemp?.Hidden === true) { actSaveTemp.Hidden = true } });
        /** Schliessen */
        var actClose = createOperation("Close", { Title: 'Schließen', Icon: 'rewind', Enabled: true, EnforceCommit: true, Execute: () => this.Close(false) });
        /** Weiter zur Kontierung */
        var actLeaveWizard = createOperation("LeaveWizard", {
            Title : 'Weiter zur Kontierung', Icon : 'rwf-leavewizard',
            Enabled: true, Hidden: "Enabled", EnforceCommit: true, Execute: () => this.EnqueueOperation(() => KWFService.LeaveWizard(this)) });
        /** Zurücksetzen */
        var actRevertToWizard = createOperation("RevertToWizard", {
            Title: 'Zurücksetzen',
            Icon: 'rwf-reverttowizard', Hidden: "Enabled",
            Enabled: true, EnforceCommit: false, Execute: () =>
                this.withConfirm("Beim Zurücksetzen des Belegs gehen alle Eingaben verloren, wollen Sie wirklich zurücksetzen?").then(() => this.EnqueueOperation(() => KWFService.RevertToWizard(this)))
        });
        /**  Ausstehende Änderungen an den Erfassungsdaten zurücknehmen */
        var actRevertPageItem = createOperation("RevertPageItem", { Enabled: true, EnforceCommit: false, Execute: () => this.EnqueueOperation(() => KWFService.RevertDisplay()) });
        /** Zeile(n) löschen */
        var actDeleteMainLine = createOperation("DeleteMainLine", {
            Enabled: true, EnforceCommit: false, Icon: 'delete', Title: 'Löschen',
            Execute: () => this.withConfirm((this.DisplayMainLineData.SelectionCount > 1 ? this.DisplayMainLineData.SelectionCount + " Belegzeilen" : "Belegzeile") + " löschen?")
                .then(() => this.EnqueueOperation(() => this.DisplayMainLineData.DeleteItems(this.DisplayMainLineData.SelectedIds)))
        });
        /** Zeilendaten nach Excel Exportieren */
        var actExcelExportMainLines = createOperation("ExcelExportLineData", {
            Enabled: true as boolean, EnforceCommit: true,
            Execute: () => {
                SaveAsExcel([
                    { Grid: mainGrid, Name: "Zeilendaten" },
                    { Grid: lugmGrid, Name: "LuGM- Daten" }].filter(item => !!item.Grid));
            }
        });
        /** Zeile Einfügen */
        var actInsertLine = createOperation("InsertMainLine", {
            Title: 'Einfügen', Icon: 'add',
            Enabled: true, EnforceCommit: true, Execute: () => this.EnqueueOperation(() =>
                this.DisplayMainLineData.InsertNewItem().then((newItem) => this.DisplayMainLineData.SetSelected(newItem)))
        });
        /** Im ReadMultiple Fall (Anordnung) : Nächstes/Voriges Element */
        var actMoveNext = createOperation("MoveNext", {
            Title: "Nächste", Icon: 'rwf-next',
            Enabled: true,
            EnforceCommit: true,
            Execute: () => this.EnqueueOperation(() => $c.when(visNavigatable.Move(1)))
        });
        var actMovePrevious = createOperation("MovePrevious", {
            Title: "Vorige", Icon: 'rwf-previous',
            Enabled: true,
            EnforceCommit: true,
            Execute: () => this.EnqueueOperation(() => $c.when(visNavigatable.Move(-1)))
        });
        /** Zeile(n) duplizieren */
        var actDuplicateMainLine = createOperation("DuplicateMainLine", {
            Title: 'Duplizieren', Icon: 'mostrecent',
            Enabled: false, EnforceCommit: true, Execute: () => this.EnqueueOperation(() => {
                var mainData = this.DisplayMainLineData;
                return mainData.DuplicateItems(mainData.SelectedIds).then(newItems => mainData.SetSelected(newItems));
            })
        });

        /** Zeile(n) in Intervalle ausmultiplizieren */
        var actMultiplyLine = createOperation("MultiplyLine", {
            Title: 'Aufteilen', Icon: 'mostrecent',
            Enabled: false, EnforceCommit: true, Execute: () => this.EnqueueOperation(() => {
                var root = this.DisplayItem,
                    mainData = this.DisplayMainLineData,
                    $c = this.$c,
                    selIds = mainData.SelectedIds;

                return ShowMultiplyDialog(mainData, selIds, DialogService).then(mInfo => {
                    const items = mainData.GetItems(mainData.SelectedIds);

                    return items.reduce((previous, current) => {
                        return previous.then(() => root.ExecuteMethod({
                            MethodName: METHOD.MultiplyLine,
                            RowProperty: current.MetaData.PropertyName,
                            RowKey: current.Model["Key"],
                            Parameters: mInfo
                        }, fn.noop, true)).then(fn.noop);
                    }, $c.when());
                });
            })
        });
        /** Lugm Zeile löschen */
        var actDeleteLugmLine = createOperation("DeleteLugmLine", {
            Enabled: false, EnforceCommit: true, Icon: "delete", Title: 'Löschen',
            Execute: () => this.withConfirm("LuGM-Zeile löschen?").then(() => this.EnqueueOperation(() => {
                return this.DisplayItem.ExecuteMethod({
                    MethodName: ROWMETHOD.DeleteLuGMAddRec,
                    RowKey: this.DisplayMainLineData.SelectedItems[0].Key,
                    RowProperty: this.DisplayItem.ClientInfo.MasterLineProperty
                });
            }))
        });
        /** LuGm Zeile einfügen */
        var actInsertLugmLine = createOperation("InsertLugmLine", {
            Title: 'Einfügen', Icon: 'add',
            Enabled: false, EnforceCommit: true, Execute: () => this.EnqueueOperation(() => {
                const triggerSelectionChanged = () => this.trigger(_Events.MainLineSelectionChanged);
                return this.DisplayItem.ExecuteMethod({
                    MethodName: ROWMETHOD.InsertLuGMAddRec,
                    RowKey: this.DisplayMainLineData.SelectedItems[0].Key,
                    RowProperty: this.DisplayItem.ClientInfo.MasterLineProperty
                }).then(triggerSelectionChanged, triggerSelectionChanged);
            })
        });
        /** Toggle Show all Lugm Lines */
        let filterLugmLines = true;
        const actToggleFilterLugmLines = createOperation("ToggleFilterLugm", {
            get Checked() { return filterLugmLines; }, // Default : Filter LuGM Line to Current Main Line's data
            set Checked(val: boolean) {
                if (val != filterLugmLines) {
                    filterLugmLines = val;
                    if (!filterLugmLines && lugmGrid)
                        lugmGrid.dataSource.filter([]);
                }
                me.trigger(_Events.MainLineSelectionChanged);
            },
            Enabled: false,
            EnforceCommit: false,
            Execute: () => {
                actToggleFilterLugmLines.Checked = !actToggleFilterLugmLines.Checked;
                return undefined;
            },
        });
        this.UserSettings.Add("MenuState", () => ({ FilterLugmLines: !!actToggleFilterLugmLines.Checked }), (val) => {
            if (typeof val.FilterLugmLines === "boolean") {
                actToggleFilterLugmLines.Checked = val.FilterLugmLines;
            }
        });

        /** Lugm Zeilen aufflüllen */
        const actLugmEnsureLines = createOperation("LugmEnsureLines", {
            // Hidden: "Enabled", ???
            EnforceCommit: true, Title: 'mit leerem Geschäftsvorfall auffüllen', Icon: 'mostviewed',
            Execute: () => this.EnqueueOperation(() => LugmEnsureLines($c, this.DisplayItem))
        });
        var lugmGrid: INavGrid, mainGrid: INavGrid;

        // Handle Remark Display
        this.one(_Events.rendered, () => {
            var displayLogEntries = this.KWFService.WFInstance.GetValue("Workflow_Log_Entries_Sub").filter(item => item.Remark);
            if (displayLogEntries.length > 0) {
                var firstLogEntry = displayLogEntries[0];
                this.AddNotification({
                    messageType: "warning",
                    hint: firstLogEntry.Remark,
                    message: `<span style="cursor:pointer" class="idms_Icon idms_Icon_Remark" ng-click="dataItem.Show()">&nbsp;({{dataItem.Count}})&nbsp;</span>` + $("<div>").text(fn.textShorten('  '
                        + firstLogEntry.Remark, 128, false) + ' (' + (firstLogEntry.CurrentWFUserName || firstLogEntry.CurrentWFUser)
                        + ' - ' + (firstLogEntry.CurrentWorkflowStepName || firstLogEntry.CurrentWorkflowStep)
                        + ' - ' + kendo.toString(firstLogEntry.Created, 'g') + ')')[0].innerHTML,
                    customData: {
                        Count: displayLogEntries.length,
                        Show: () => {
                            return DialogService.ShowWindow({
                                controllerAs: 'vm',
                                windowOptions: {
                                    resizable: true,
                                    minWidth: 350,
                                    modal: true,
                                    //actions: ["Restore", "Maximize", "Close"],
                                    title: 'Bemerkungen im Workflowprotokoll (' + displayLogEntries.length + ')'
                                },
                                controller: ['$scope', function ($scope) {
                                    this.LogEntries = displayLogEntries.map(entry => ({
                                        Created: kendo.toString(entry.Created, 'g'),
                                        CurrentWFUserName: entry.CurrentWFUserName || entry.CurrentWFUser,
                                        CurrentWorkflowStepName: entry.CurrentWorkflowStepName,
                                        Remark: entry.Remark
                                    }));
                                }],
                                template:
                                    `<div ng-repeat="LogEntry in vm.LogEntries" style='border-bottom: 10px; width : 100%'>
    <div>
        <span class="idms_Icon idms_Icon_Remark" >&nbsp;
            {{LogEntry.CurrentWFUserName}} - {{ LogEntry.CurrentWorkflowStepName }} - {{LogEntry.Created}}
    </div>
    <div style='font-size: large; white-space: pre-wrap; word-wrap: break-word; padding: 4px; overflow : hidden'>{{LogEntry.Remark}}</div>
    <br>
</div>`
                            });
                        }
                    },
                });
            }
        });

        this.bind(_Events.rendered, (e: { element: JQuery }) => {
            const myEl = e && e.element && e.element[0];
            /** Filter out other child Zones (e.g. PurchOrder ...) */
            const filterMyChildren = (q: JQuery) => q.filter((idx, el) => {
                var check = $(el).closest(":data(kendoNavPageitemDockZones)");
                return check[0] && check[0] === myEl;
            });

            lugmGrid = filterMyChildren($(".k-grid[navPropertyName=" + PROP_LuGMAddRec + "]")).data("kendoNavGrid");
            var ml = this.DisplayMainLineData;
            mainGrid = ((ml instanceof NavLineData) && filterMyChildren($(".k-grid[navPropertyName=" + ml.Property.Name + "]")).data("kendoNavGrid")) || undefined;

            if (mainGrid instanceof NavItemsGrid) {
                this.one(_Events.rendered, mainGrid.SetReadonly((forInsert) => forInsert && !actInsertLine.Enabled));
            }

            // esnure main grids can be identified (e.g. for context menu binding ...)
            [mainGrid, lugmGrid].filter(fn.isSet).forEach(item => item.wrapper.attr("mainViewGrid", "true"));

            actExcelExportMainLines.Enabled = !!mainGrid;

            //#region Sync LugmGrid Sort
            if (mainGrid && lugmGrid && lugmGrid.dataSource && mainGrid.dataSource) {
                let inSort = false,
                    execSort = () => {
                        const idxField = "__MainIdx";
                        if (inSort)
                            return;
                        inSort = true;

                        try {
                            let lugmData = lugmGrid.dataSource,
                                mainData = mainGrid.dataSource,
                                mainItems = mainData.view();

                            lugmData.data().forEach(item => {
                                if (item && item[idxField] == undefined) {
                                    Object.defineProperty(item, idxField, { enumerable: false, writable: true });
                                }
                                var mainNo = item[PROP_Entry_No],
                                    mainIdx = -1;
                                if (mainNo) {
                                    fn.FindFirst(mainItems, (cMain, idx) => {
                                        var result = cMain[PROP_AddRecLuGMEntryNo] == mainNo;
                                        if (result) {
                                            mainIdx = idx;
                                        }
                                        return result;
                                    });
                                }
                                item[idxField] = mainIdx;
                            });
                            var sort = (lugmGrid.dataSource.sort() || []).filter(item => item.field !== idxField);
                            sort.unshift({ field: idxField, dir: "asc" });
                            lugmGrid.dataSource.sort(sort);
                            this.trigger(_Events.MainLineSelectionChanged);
                        } finally {
                            inSort = false;
                        }
                    };

                execSort();

                mainGrid.one(kconstants.NavDestroy, kBind(mainGrid.dataSource, execSort, "requestEnd"));

                // Problem : must be executed on insert/duplicate new LugmLine also
                let onCreateLugmLine = (s: { Action: string }) => {
                    const action = s && s.Action;
                    if ((action == "InsertLugmLine") || (action == "DuplicateMainLine")) {
                        execSort();
                    }
                };
                this.one(_Events.rendered, kBind(this, onCreateLugmLine, "ActionExecuted"));
            }
            //#endregion

        });
        this.bind(_Events.MainLineSelectionChanged, () => {
            var mainLine = this.DisplayMainLineData;
            var lugmLine = this.DisplayLugMData;
            if (lugmLine && mainLine) {
                if (actToggleFilterLugmLines.Checked) {
                    const lugmDs = lugmGrid && lugmGrid.dataSource;
                    if (lugmDs) {
                        if (mainLine.SelectedIds.length > 0) {
                            var filters = <kendo.data.DataSourceFilters>{ logic: "or", filters: mainLine.SelectedItems.map(item => { return { field: PROP_Entry_No, operator: "eq", value: item.Model[PROP_AddRecLuGMEntryNo] }; }) };
                            lugmDs.filter(filters);
                        } else {
                            lugmDs.filter([]);
                        }
                    }
                } else {
                    if (mainLine.SelectedItems.length == 1) {
                        var id = mainLine.SelectedItems[0].GetValue(PROP_AddRecLuGMEntryNo);
                        lugmLine.SetSelected(lugmLine.Items.filter(check => check.GetValue(PROP_Entry_No) == id));
                    } else {
                        lugmLine.SetSelected([]);
                    }
                }
            }
        });
        this.bind(_Events.LuGMLineSelectionChanged, () => {
            var mainLine = this.DisplayMainLineData;
            var lugmLine = this.DisplayLugMData;
            if (!actToggleFilterLugmLines.Checked) {
                if (lugmLine.SelectedItems.length == 1) {
                    var id = lugmLine.SelectedItems[0].GetValue(PROP_Entry_No);
                    mainLine.SetSelected(mainLine.Items.filter(check => check.GetValue(PROP_AddRecLuGMEntryNo) == id));
                } else {
                    mainLine.SetSelected([]);
                }
            }
        });

        const actToggleSubscription = createOperation("ToggleSubscription", {
          EnforceCommit: false,
          Title: 'Abo ...',
          Hidden: true,
          Enabled: !!$rwf.RwfSettings.CheckPages.FDRW_WF_Instance_Subscriptions,
          Checked: true as boolean,
          Refresh : (withToggle: boolean) =>
            NavClient.LoadPageItems<IFDRW_WF_Instance_Subscriptions>({
              InstanceID: WFInstance.Model.IDAsText,
              PageName: "FDRW_WF_Instance_Subscriptions",
              Constraints: [
                { FieldName: "Workflowinstanz", Value: WFInstance.Model.IDAsText },
                { FieldName: "Workflowbenutzer", Value: $rwf.RwfUser.ID }
              ],
              PageCount: 2
            }, WFInstance.ClientInfo.NavUrl).then(s => {
              if(withToggle) {
              if(s.Items.length == 0) {
                return NavClient.CreateNew(s.ClientInfo, {
                  "Workflowinstanz" : WFInstance.Model.IDAsText,
                  "Workflowbenutzer" : $rwf.RwfUser.ID
                 }).Update(fn.noop, true).then(() => actToggleSubscription.Refresh(false));

              } else {
                return s.DeleteItems(s.Items).then(() => actToggleSubscription.Refresh(false));
              }
            } else {
              actToggleSubscription.Checked = s.Items.length > 0;
            }
            }),
          Execute: () =>  $c.when(actToggleSubscription.Refresh(true)).then(fn.noop, err => DialogService.ShowError(fn.resolveToError(err)))
        });
        if(actToggleSubscription.Enabled) {
          actToggleSubscription.Hidden = false;
          actToggleSubscription.Refresh(false);
        }

        /** SignaturDokument öffnen */
        var actOpenSignDoc = createOperation("OpenSignDoc", {
            Enabled: false, Hidden: "Enabled", EnforceCommit: false,
            Execute: () => {
                var signWindow = this["_navSignWindow"];
                if (signWindow && signWindow.close) {
                    signWindow.close();
                }
                this["_navSignWindow"] = window.open(this.CurrentState.SignatureDocumentUrl,
                    'Anordnung', 'dependent=yes,resizable=yes,width=1000,height=700');
                return $c.when();
            }
        });
        /**  Mittel Reservieren */
        /** Mark is fundsReserved called and still valid */
        var fundsReserved = false;
        /** Handle Invalidation of funsreserved */
        this.bind(_Events.displaychange, () => {
            fundsReserved = false;
            if (this.Anchor)
                this.bind(_Events.displaychange, this.Anchor.RegisterPropertyChanged(null, () => {
                    fundsReserved = false;
                }));
        });
        var actReserveFunding = createOperation("ReserveFunding", {
            Enabled: false, Hidden: IsStandaloneUser ? true : "Enabled",
            EnforceCommit: true,
            Execute: () => this.EnqueueOperation(() => KWFService.ReserveFunds(this).then(() => { fundsReserved = true; return undefined; }, err => {
                if (fn.error.IsCancel(err))
                    throw err; // No Display for Cancelation
                // Explicit Error Handling (Show Context 'Mittelreservierung')
                return DialogService.ShowDialog({
                    message: resolveToError(err, false),
                    title: "Fehler bei der Mittelreservierung",
                }).then(() => { throw __confirmError; });
            }))
        });
        var actPostingCheck = createOperation("PostingCheck", {
            Enabled: true, Hidden: IsStandaloneUser ? true : "Enabled",
            EnforceCommit: true,
            Execute: () => this.EnqueueOperation(() => {
                return this.ExecutePostingCheck({
                    get mainGrid() { return mainGrid; }
                });
            })
        });
        // Bestellung erzeugen
        const actCreateOrderForBWF = createOperation("CreateOrderForBWF", {
            Enabled: true, Hidden: "Enabled",
            EnforceCommit: true,
            Execute: () => this.EnqueueOperation(() => {
                const wfInstance = this.KWFService.WFInstance,
                    wfDocs = wfInstance.Model.Workflow_Documents_Sub,
                    prev = wfDocs.map(item => item.ID);
                return wfInstance.ExecuteMethod({ MethodName: METHOD.CreateOrderForBWF, Parameters: {} })
                    .then(() => {
                        const newDocs = fn.except(wfDocs.map(item => item.ID), prev);
                        if (newDocs.length == 1) {
                            // Position on Created Document
                            angular.element(window.document.documentElement).scope().$broadcast(SetCurrWFDocument, newDocs[0]);
                        }
                    }, err => { DialogService.ShowError(err); })
                    .then(() => this.DisplayItem.RevertItem(true)); // RevertItem : This Method on WFInstance might manipulate  Displayed Purchase Document
            })
        });
        /** Verteilung auflösen (Doppisch)*/
        var actResolveDistribution = createOperation("ResolveDistribution", {
            Title: 'Verteilung auflösen', Icon: 'share', Hidden: "Enabled",
            Enabled: true, EnforceCommit: true, Execute: () => this.EnqueueOperation(() => this.DisplayItem.ExecuteMethod({
                MethodName: ROWMETHOD.ResolveDistribution,
                RowKey: this.DisplayMainLineData.SelectedItems[0].Key,
                RowProperty: this.DisplayItem.ClientInfo.MasterLineProperty
            }))
        });

        /** Verteilung auflösen (Kameral)*/
        let actKamResolveDistribution = createOperation("KAM_ResolveDistribution", {
            Title: 'Aufteilen',
            EnforceCommit: true, Hidden: !(KWFService.IsKameral && KWFService.WFSettings.IsHUELAufteilungActive), Execute: () =>
                this.EnqueueOperation(() => CtrlHuelaufteilung.ShowModal($c, KWFService))
        });

        /** Buchungsbeschreibung in die Belegzeilen kopieren */
        var actWritePostingDescrInLineDescr = createOperation("WritePostingDescrInLineDescr", {
            Title: 'Buchungsb. kopieren', Icon: 'rwf-down',
            EnforceCommit: true, Enabled: false, Hidden: "Enabled",
            Execute: () => this.EnqueueOperation(() => this.DisplayItem.ExecuteMethod({ MethodName: METHOD.WritePostingDescrInLineDescr }))
        });
        /** Bestellinformation anzeigen */
        var actShowOrder = createOperation("ShowOrder", { Title: 'Bestellauskunft', Icon: 'info', Enabled: false, Hidden: "Enabled", EnforceCommit: true, Execute: () => this.EnqueueOperation(() => this.ShowOrderInfo()) });
        /** Benutzereinstellungen zur aktuellen Ansicht zurücksetzen */
        var actResetUserViewSettings = createOperation("ResetCurrentUserView", {
            Enabled: true, EnforceCommit: false, Execute: () =>
                this.EnqueueOperation(() => {
                    var item = this.DisplayItem;
                    var view = this.DisplayView;
                    if (!item || !view)
                        throw new Error("Keine Ansicht geladen!");
                    return this.SetCurrentDisplayItem(undefined, null).then(() => {
                        const result = this.NavSettings.GetUserSetting(view.UserPersistToken).DeleteValue();
                        const doFinal = () => this.SetCurrentDisplayItem(item, view);
                        return result.then(doFinal, doFinal);
                    });
                })
        });
        // Aktion "Splittungsring wählen"
        var actAOSplit = createOperation("AOSplit", {
            Title: 'Splittungsring einfügen',
            Enabled: true, Hidden: "Enabled", EnforceCommit: true, Execute: () => {
                var currItem = this.DisplayItem;
                return this.NavClient.GetPageClientInfo("FDRW_Splittungsring", currItem.ClientInfo).then(pg => {
                    return ShowModalReadMultipleSelect({
                        TargetPage: pg,
                        NavUrl: currItem.ClientInfo,
                        Constraints: ["Gemeindenr", "Haushaltsjahr"].map(fld => { return { FieldName: fld, Value: currItem.GetValue(fld) }; }),
                        Title: "Splittungsring wählen",
                        PersistToken: "AOSplitSelect",
                        DetailConfig: {
                            template: `<div></div>`,
                            init: (e) => {
                                var detailRow = $(e.detailCell),
                                    propDetail = "RingHaushaltsstelle",
                                    detailData = <any[]>e.data[propDetail];
                                if (!(detailData && detailData.length)) {
                                    $("<div>Keine Konfiguration hinterlegt!</div>").prependTo(detailRow);
                                    return;
                                }
                                var meta = pg.MetaData.PropsByName[propDetail].ArrayProperties;

                                $("<div style='width:100%'></div>").prependTo(detailRow).kendoNavGrid({
                                    columns: meta.Properties.map(m => meta.GetColumn(m)),
                                    dataSource: detailData
                                });
                            }
                        }
                    }, this.$c).then(sRing => {
                        return sRing && currItem.ExecuteMethod({
                            MethodName: METHOD.ResolveSplittungsring,
                            Parameters: { splittungsringNummer: sRing["Nummer"], erfassungszeileHUEL: currItem.Key }
                        });
                    });
                });
            }
        });
        const actApplyRecurringLines = createOperation("ApplyRecurringLines", {
            Title: 'Wiederkehrende Zeilen einfügen', Icon: 'mostviewed',
            Enabled: false, Hidden: "Enabled", EnforceCommit: true,
            Execute: () => {

                const currItem = this.DisplayItem;
                const isSales = currItem.PageName === FDDI_DMS_Sales_Document;
                const detailPage = isSales ? "FDRW_Standard_Sales_Code" : "FDRW_Standard_Purchase_Code";
                const constraints: IPageQueryConstraint[] = isSales ?
                    [{ FieldName: "Customer_No", Value: currItem.GetValue("Sell_to_Customer_No") }] :
                    [{ FieldName: "Vendor_No", Value: currItem.GetValue("Buy_from_Vendor_No") }];
                return this.NavClient.GetPageClientInfo(detailPage, currItem.ClientInfo)
                    .then(pg => {
                        const initialData = this.NavClient.ReadMultiple(
                            { Constraints: constraints, PageName: detailPage, PageCount: -1 }, currItem.ClientInfo).then(resultData => {
                                if (resultData.Data.length == 0) {
                                    return DialogService.ShowError("Es konnten keine wiederkehrenden Zeilen gefunden werden.").then(() => {
                                        fn.error.ThrowCancel();
                                        return <IPageQueryResult>undefined;
                                    });
                                };
                                return resultData;
                            });
                        return ShowModalReadMultipleSelect({
                            TargetPage: pg,
                            NavUrl: currItem.ClientInfo,
                            Constraints: constraints,
                            Title: "Wiederkehrende Zeile wählen",
                            PersistToken: "ApplyRecurringLinesSelect",
                            InitialData: initialData
                        }, this.$c).then(recLine => {
                            if (!recLine) {
                                return;
                            }
                            const params = isSales ? {
                                stdCustCode: recLine["Code"],
                                parentSalesHeader: currItem.Key
                            } : {
                                    stdVendPurchCode: recLine["Code"],
                                    parentPurchHeader: currItem.Key
                                };
                            return currItem.ExecuteMethod({
                                MethodName: "ApplyRecurringLines",
                                Parameters: params
                            });
                        });
                    });
            }
        });

        // Anzeige für "Anlagen Teilverkauf"
        var actFAPartDispose = createOperation("FAPartDispose", {
            Title: 'Anlagen Teilverkauf',
            Icon: 'featured',
            Enabled: false,
            Hidden: "Enabled",
            EnforceCommit: true,
            Execute: () => {
                const $c = this.$c;
                const NoEdit = this.NoEdit;
                const result = this.EnqueueOperation(() => ShowFAPartDispose($c, singleMainItem, NoEdit));
                if (!NoEdit) {
                    result.then(r =>
                        $c.finally(r.close,
                            () => this.EnqueueOperation(() => singleMainItem.Root.RevertItem(true))
                        ));
                }
                return result;
            }
        });
        //#endregion

        //#region register Action Invalidators

        let opGetInvalidActions = new Array<() => IKWFOperation[]>();

        const preValidators = new Array<() => void>();
        const postValidators = new Array<() => void>();
        /** Registers Function to Invalide Action(s) on Condition */
        var invalidate = fn.proxy(function (invalidator: () => boolean, ...ops: IKWFOperation[]) {
            var invalid = fn.proxy(invalidator, this);
            opGetInvalidActions.push(() => invalid() && ops);
        }, this);
        /** Action to call before (in)validating*/
        const preValidate = fn.proxy((preAction: () => void) => preValidators.push(preAction), this);
        const postValidate = fn.proxy((postAction: () => void) => postValidators.push(postAction), this);

        var DisplayItem: DisplayPageItem,
            DisplayPage: DisplayPage_Main,
            MainLineData: NavPropertyItems,
            mainLineMetaData: IPageMetaData,
            customInfo = mainLineMetaData && mainLineMetaData.CustomInfo,
            container: NavPropertyItems,
            visNavigatable: NavPropertyItems,
            NoEditCustom: boolean, //  "CurrentStep.IsReadonly" NOT Considred
            NoRevertToWizard: boolean, // Allows in Breakout (CustomState.NodeEditContent) Scenario
            NoEdit: boolean, // Including CurrentStetp.IsReadonly
            HasMissingLugmLines: boolean,
            WizardItem: NavPageItem;
        preValidate(() => {
            DisplayItem = <DisplayPageItem>this.DisplayItem;
            WizardItem = this.KWFService?.WizardItem;
            DisplayPage = this.DisplayPageName;
            MainLineData = this.DisplayMainLineData;
            mainLineMetaData = MainLineData && MainLineData.MetaData;
            HasMissingLugmLines = this.DisplayLugMData && !!fn.FindFirst(MainLineData && MainLineData.Items, item => !item.Model[PROP_AddRecLuGMEntryNo]);
            customInfo = mainLineMetaData && mainLineMetaData.CustomInfo;
            container = DisplayItem && DisplayItem.Container;
            visNavigatable = this.VisibleNavigatable;
            NoRevertToWizard = (this.CurrentState && this.CurrentState.NoEditContent) || !this.KWFService.IsCheckedOut;
            NoEditCustom = this.CustomState.NoEditContent || NoRevertToWizard;
            NoEdit = this.NoEdit;
        });

        invalidate(() => !KWFService.IsCheckedOut, actSaveTemp, actReserveFunding);
        // Actions Invalid in "PageItem Edit not allowed"
        invalidate(() => NoEdit,
            actRevertPageItem, actAOSplit, actApplyRecurringLines);

        // ReserveFunds : Mandatory overrides NoEdit
        invalidate(() => NoEdit && !(this.MandatoryActions && this.MandatoryActions.ReserveFunds), actReserveFunding);
        invalidate(() => !(container || (customInfo && customInfo.InsertRowMethod)), actInsertLine);
        invalidate(() => !(container || (customInfo && customInfo.DuplicateRowMethod)), actDuplicateMainLine);
        invalidate(() => !(container || (customInfo && customInfo.DeleteRowMethod)), actDeleteMainLine);

        // "Actions not on Wizard"
        invalidate(() => (!DisplayItem) || DisplayPage == WizardPagename,
            actRevertToWizard, actDeleteMainLine, actMultiplyLine, actDeleteLugmLine, actInsertLugmLine, actLugmEnsureLines, actReserveFunding,
            actResolveDistribution, actWritePostingDescrInLineDescr, actPostingCheck);
        // Signature : "no on wizard" (only for main doc signature), bot on FWF
        invalidate(() => !this.IsFWF && ((!DisplayItem) ||
            (
                DisplayPage == WizardPagename
                && (!IsMainDocSignatureForced(this.$rwf.RwfSetup, this.validatedRoutingAction))
            )
        ),
            actSign);

        // Actions only on Wizard
        invalidate(() => !DisplayItem || DisplayPage != WizardPagename,
            actLeaveWizard);
        invalidate(() => IsStandaloneUser || hasSourceRecord, actLeaveWizard);
        // actions not on sales
        invalidate(() => DisplayPage == FDDI_DMS_Sales_Document || !this.DisplayItem,
            actReserveFunding);

        // Mittelreservierung : nicht auf Einkaufsgutschriften (US215161)
        invalidate(() => DisplayPage == FDDI_DMS_Purchase_Document &&
            (this.DisplayItem as NavPageItem<IFDDI_DMS_Purchase_Document>).GetValueEx("Document_Type") == "Credit_Memo", actReserveFunding)

        if (this.KWFService.IsKameral) {
            // FA_Posting_Type: only in AT ?!?
            invalidate(() => !IsATAO(DisplayItem) || DisplayItem.GetValueEx("FA_Posting_Type") != "Partial_Disposal"
                || !DisplayItem.GetValue("Anlagennr"), actFAPartDispose);
        } else {
            invalidate(() => !this.DisplayItem, actFAPartDispose);
            // FAPartDispose : nur bei WG/anlage + Anlagenteilverkauf auf Verkaufsrechnung
            invalidate(() => singleMainItemType != "Fixed_Asset" || singleMainItem.GetValueEx("FA_Posting_Type") != "Partial_Disposal"
                || (["Invoice", "Credit_Memo"].indexOf((DisplayItem as NavPageItem)?.GetValueEx("Document_Type")) < 0), actFAPartDispose);
        }

        // actions only on Purchase
        invalidate(() => DisplayPage != FDDI_DMS_Purchase_Document, actCreateOrderForBWF);

        // action not on Auftragsbuchblatt
        invalidate(() => DisplayPage == FDRW_Auftragsbuchblatt, actReserveFunding);

        // action not on Anordnungsbaltt only for Ausgabe_SK
        invalidate(() => (DisplayPage == FDRW_Anordnungsblatt) &&
            (WizardItem.GetValueEx("EinnahmeAusgabe") != "Ausgabe_SK"),
            actReserveFunding);
        // Splittungsring wählen : only if Method on item Available
        invalidate(() => !(KWFService instanceof RWF3BaseService && KWFService.WFSettings.IsSplittungsringActive) || !DisplayItem || !DisplayItem.ClientInfo.AllMethods[METHOD.ResolveSplittungsring], actAOSplit);
        // Wiederkehrende Buchzeilen anwenden nur im doppischen fall
        invalidate(() => [FDDI_DMS_Purchase_Document, FDDI_DMS_Sales_Document].indexOf(this.DisplayPageName) < 0, actApplyRecurringLines);

        invalidate(() => !visNavigatable || visNavigatable.Count == 1 && (visNavigatable.SelectionCount > 0), actMoveNext, actMovePrevious);
        invalidate(() => !(visNavigatable && visNavigatable.FirstSelected !== visNavigatable.Items.length - 1), actMoveNext);
        invalidate(() => !(visNavigatable && visNavigatable.FirstSelected !== 0), actMovePrevious);

        invalidate(() => !(METHOD.CreateOrderForBWF in allInstanceMethods) || (!WizardItem || [Reservation, PurchOrderChange].indexOf(WizardItem.GetValueEx("Creation_Type")) < 0), actCreateOrderForBWF);
        invalidate(() => !WizardItem || isRechnungMitBestellbezug(DisplayItem) || [Reservation, PurchOrderChange].indexOf(WizardItem.GetValueEx("Creation_Type")) >= 0, actResolveDistribution);
        invalidate(() => !(METHOD.PostingCheck in allInstanceMethods), actPostingCheck);
        invalidate(() => [FDDI_DMS_Purchase_Document, FDDI_DMS_Sales_Document].indexOf(DisplayPage) < 0 || (!WizardItem || [Reservation, PurchOrderChange].indexOf(WizardItem.GetValueEx("Creation_Type")) >= 0), actPostingCheck);
        // #region Check for Method Availablity
        /** Methods Available on Current DisplayItem */
        let allDisplayItemMethods = <INamed<boolean>>{},
            /** If set: it's NOT an RWF (but an FWF) */
            hasSourceRecord: boolean,
            allInstanceMethods = <INamed<boolean>>{};

        preValidate(() => {
            const WFInstance = this.KWFService.WFInstance;
            allDisplayItemMethods = (DisplayItem && DisplayItem.ClientInfo.AllMethods) || <any>{};
            allInstanceMethods = (WFInstance && WFInstance.ClientInfo.AllMethods) || <any>{};
            hasSourceRecord = WFInstance && !!WFInstance.Model.SourceRecord;
        });
        invalidate(() => !allDisplayItemMethods[ROWMETHOD.ResolveDistribution], actResolveDistribution);
        // Buchungsbeschreibung übernehmen freischalten , wenn  "Beschreibung" in Zeile editierbar (auch wenn Ansicht gepserrt.
        invalidate(() => !allDisplayItemMethods[METHOD.WritePostingDescrInLineDescr] || !mainLineMetaData ||
            !mainLineMetaData.PropsByName.Description ||
            MainLineData.Items.every(item =>
                this.Anchor.Readonly.GetValue(mainLineMetaData.PropertyName + ".Description", item)),
            actWritePostingDescrInLineDescr);
        invalidate(() => !allDisplayItemMethods[METHOD.MultiplyLine], actMultiplyLine);
        // #endregion

        // CheckOrder only on Purchase
        invalidate(() => IsStandaloneUser || !(isRechnungMitBestellbezug(this.DisplayItem as DisplayPageItem) || isPurchOrderChange(this.DisplayItem as DisplayPageItem)), actShowOrder);
        // Revert / save Makes only sense if DisplayItem is not in sync
        invalidate(() => (!this.DisplayItem) || this.DisplayItem.IsInSync, actRevertPageItem);
        // Signature
        invalidate(() => (!this.CurrentState) || !this.CurrentState.SignatureEnabled,
            actSign, actOpenSignDoc);
        invalidate(() => this.MandatoryActions?.SignatureMandatory, actRoute);
        invalidate(() => this.CurrentState?.NoRouting || this.CustomState?.NoRouting , actRoute, actSign, actSelectRoutingAction, actSelectSubRoutingAction);
        invalidate(() => !this.SelectedRootAction || !(this.SelectedRootAction._Items && this.SelectedRootAction._Items.length), actSelectSubRoutingAction);

        invalidate(() => !lugmGrid, actToggleFilterLugmLines);

        // Existing Signature Document
        invalidate(() => !this.CurrentState || !this.CurrentState.SignatureDocumentUrl,
            actOpenSignDoc);
        // Routing Action needs selected Routing item
        invalidate(() => !this.validatedRoutingAction, actRoute, actSign);

        invalidate(() => this.MandatoryActions && !this.MandatoryActions.SignatureMandatory, actSign);

        /** List of Selected Id's for Main Line Data */
        var mainLineSelIds = <string[]>[];
        /** Single Selected Main Item */
        var singleMainItem: NavPropertyItem;
        /** Current Line item has Order Ref */
        var singleMainItemOrderLineNo: any;
        /** "Type" of a single Selected Main Linle Item as Enum String */
        var singleMainItemType: string;
        preValidate(() => {
            var mainLines = this.DisplayMainLineData;
            mainLineSelIds = (mainLines && mainLines.SelectedIds) || [];
            singleMainItem = (mainLineSelIds.length == 1 && mainLines.GetItems(mainLineSelIds[0])[0]) || undefined;
            singleMainItemType = singleMainItem && singleMainItem.GetValueEx("Type", false);
            singleMainItemOrderLineNo = isRechnungMitBestellbezug(this.DisplayItem) && singleMainItem?.GetValue(PROP_Order_Line_No);
        });

        // Delete Main Line : One must remain
        invalidate(() => mainLineSelIds.length == 0 || mainLineSelIds.length >= this.DisplayMainLineData.Count,
            actDeleteMainLine);
        // Actions that need at least one Selected Items
        invalidate(() => mainLineSelIds.length == 0, actDuplicateMainLine, actMultiplyLine, actDeleteMainLine);
        // Actions that need exactly one Selected Main Line Item
        invalidate(() => mainLineSelIds.length != 1, actResolveDistribution, actFAPartDispose);
        // Manipulate Selected LugmLine Data
        invalidate(() => !this.CurrentState.LugmEnabled,
            actDeleteLugmLine, actInsertLugmLine, actLugmEnsureLines);

        // LugmEnsureLines: only if Missing lines available
        invalidate(() => !HasMissingLugmLines, actLugmEnsureLines);

        invalidate(() => !singleMainItem || singleMainItem.GetValue(PROP_AddRecLuGMEntryNo) == 0,
            actDeleteLugmLine);

        invalidate(() => !singleMainItem || singleMainItem.GetValue(PROP_AddRecLuGMEntryNo) > 0,
            actInsertLugmLine);

        invalidate(() => !!singleMainItemOrderLineNo, actDeleteLugmLine, actInsertLugmLine);

        // Actions Invalid in "NoChangeDisplay" Mode
        invalidate(() => NoEditCustom, actLeaveWizard, actDuplicateMainLine, actMultiplyLine,
            actInsertLine, actInsertLugmLine, actLugmEnsureLines, actDeleteMainLine, actDeleteLugmLine, actResolveDistribution);
        invalidate(() => NoRevertToWizard, actRevertToWizard);
        var lockedActions = KWFService.CurrWFStep,
            isCurrentStepReadonly: boolean;
        preValidate(() => lockedActions = KWFService.CurrWFStep);
        preValidate(() => isCurrentStepReadonly = this.CurrentState && this.CurrentState.CurrentStepReadOnly == true);
        // Convention: If Step Is readonly, "...Locked" means "...Unlocked",
        let customLockedHandling = (lockedProp: keyof rwf3.IFDRW_Workflow_Step_List, op: IKWFOperation[]) =>
            opGetInvalidActions.push(() => lockedActions && (lockedProp in lockedActions) && (!lockedActions || (isCurrentStepReadonly != lockedActions[lockedProp])) && op);
        customLockedHandling("ResolveDistributionLocked", [actResolveDistribution]);
        customLockedHandling("DeleteLineLocked", [actDeleteMainLine, actDeleteLugmLine]);
        customLockedHandling("InsertNewLineLocked", [actInsertLine, actInsertLugmLine, actLugmEnsureLines]);
        customLockedHandling("DuplicateLineLocked", [actDuplicateMainLine, actMultiplyLine]);
        customLockedHandling("ResetWizardLocked", [actRevertToWizard]);
        customLockedHandling("LeaveWizardLocked", [actLeaveWizard]);

        // see Tab "Aktionen" in editform.html
        const tabActionsOperations = ["OpenSignDoc", "ReserveFunding", "PostingCheck", "CreateOrderForBWF"];
        const actTabActions = createOperation("TabActions", <any><Partial<IKWFOperation>>{ Hidden: false });
        postValidate(() => {
            actTabActions.Hidden = !fn.FindFirst(tabActionsOperations, item => {
                const curr = KWFOperations[item];
                return curr && (curr.Hidden == "Enabled" ? curr.Enabled : !curr.Hidden);
            });
        });

        invalidate(() => [FDRW_Anordnungsblatt, FDRW_Auftragsbuchblatt].indexOf(this.DisplayPageName) < 0, actKamResolveDistribution);
        // Remap Defined Actions Executions to ensure
        // - Validation before Execution
        // - trigger defer - interceptors
        // - EnforceCommit if configured
        allOperations.forEach((op) => {
            var orig = op.Execute;
            if (orig) {
                op.Execute = () => {
                    revalidate();
                    fn.validate(!this.IsDestroyed, "Aktion nicht möglich : Element nicht mehr gültig!");
                    fn.validate(op.Enabled, "Operation nicht möglich!");

                    // as we do not focus Buttons bound to operations anymore, but we need to trigger change if EnforceCommit = true
                    var restoreFocus = op.EnforceCommit && document.activeElement && $(document.activeElement),
                        restoreCell = $(restoreFocus).parents("td[role='gridcell']"),
                        doRestoreFocus = restoreFocus && $(restoreFocus).blur() && (() => {
                            if (!this.IsDestroyed) {
                                if (restoreFocus.is(":visible"))
                                    restoreFocus.focus();
                                else if (restoreCell.is(":visible")) {
                                    restoreCell.focus();
                                }
                            };
                        });

                    // Allow Promise Interceptors for all Actions
                    return this.triggerWithDefer(this.$c, op.name).then(() => {
                        // Enforce Commit if Configured
                        if (op.EnforceCommit)
                            var resolvedOrig = $c.finally(this.EnsureCommit().then(orig), doRestoreFocus);
                        else
                            resolvedOrig = $c.when(orig());

                        $c.finally<void>(resolvedOrig, () => {
                            op.IsRunning = false;
                            this.trigger(SessionEvents.ActionExecuted, { Action: op.name });
                        });
                        op.IsRunning = true;
                        return resolvedOrig;
                    });
                };
            }
        }, this);

        /** get DocumentTitle from Current State */
        function calculateDocumentTitle() {
            if (!DisplayItem) {
                // Title for FWF
                return KWFService?.WFInstance?.Model.SourceRecordAsText ?? "";
            }

            let title: string,
                /** rechnung, bestellung */
                lowerDocType = ((<NavPageItem>DisplayItem).GetDisplayValue("Document_Type") || "").toLowerCase();

            switch (DisplayItem.PageName) {
                case FDDI_DMS_Purchase_Document:
                    if (DisplayItem.GetValue(PROP_OrderNo)) {
                        switch (DisplayItem.GetValue("Document_Type")) {
                            case /**Order*/1:
                                if ((KWFService.WizardItem as NavPageItem<rwf3.IFDDI_Wizard_Create_New_DMS_Document>).GetValueEx("Creation_Type") == "Reservation") {
                                    title = "Einkaufsbestellung";
                                } else {
                                    title = "Bestelländerung";
                                }
                                break;
                            default:
                                title = "Rechnung mit Bestellbezug";
                                break;
                        }
                    }
                    else
                        title = "Einkaufs" + lowerDocType;
                    break;
                case FDDI_DMS_Sales_Document:
                    title = "Verkaufs" + lowerDocType;
                    break;
                case FDDI_Wizard_Create_New_DMS_Document:

                    if (DisplayItem.GetValue("Document_Type") == 1 && DisplayItem.GetValue("Accounting") == 1) {
                        switch (DisplayItem.GetValueEx("Creation_Type")) {
                            case Reservation:
                                title = "Einkaufsbestellung";
                                break;
                            case PurchOrderChange:
                                title = "Bestelländerung";
                                break;
                            default:
                                title = "Rechnung mit Bestellbezug";
                        }
                    } else
                        title = DisplayItem.GetDisplayValue("Accounting") + "s" // "Verkauf" / "Einkauf" + "s"
                            + lowerDocType;
                    break;
                case FDRW_Wizard:
                    title = DisplayItem.GetDisplayValue("EinnahmeAusgabe");
                    break;
                case FDRW_Anordnungsblatt:
                    title = DisplayItem.GetDisplayValue("Ein_Aus");
                    break;
                case FDRW_Auftragsbuchblatt:
                    title = "Auftragsanordnung";
                    break;
                case FDRW_Auftrag:
                    title = "Mittelreservierung";
                    break;
                default:
                    fn.never(DisplayItem, (DisplayItem as NavPageItem).PageName);
            }
            return title;
        };

        /** Action to Refresh Enabled State of Actions, Recalculate Titles, etc */
        var revalidate = () => {
            // first refresh Prevalidators
            preValidators.forEach(pre => pre());
            // calculate invalid ops
            var invalidOps = fn.ToDictionary(
                fn.FlattenArray(opGetInvalidActions.map(item => item() || [], this)),
                op => op.name);
            // Refresh Enabled state on all actions
            allOperations.forEach(op => op.Enabled = !invalidOps[op.name]);

            this.DisplayTitle = calculateDocumentTitle() || this.DisplayTitle;

            // Hide Route if Signing Visible (exlcusive ...)
            actRoute.Hidden = actSign.Enabled && !actRoute.Enabled;

            postValidators.forEach(post => post());
        };

        this.bind(_Events.change, revalidate);

        const onDisplayChange = () => {
            actMovePrevious.Hidden = actMoveNext.Hidden = !this.VisibleNavigatable;
        };

        this.bind(_Events.displaychange, onDisplayChange);
        onDisplayChange();
        //#endregion

        //#endregion
    }

    /** Register Callback to be notified upon Change of current Display Item, returns "Unbind" Function for Deregistration;
     * Used to Bind NavPageItemEditor to Current Display Entry of an Form Session Instance
      */
    public RegisterDisplayChange: (cb: (options: INavPageItemEditOptions) => void) => Function;

    /** Notification about RenderComplate of Visualization */
    public Rendered: (element: JQuery) => void;
    private _Rendered(element: JQuery) {

        // First "SaveAnnotations" might invalidate Instance Key ---> Revert Instance Item
        const FirstAnnotSaveOp = this.$c.defer();
        const RWFAnnotationsSaved = fn.once(() => {
            UnWRfSave();
            FirstAnnotSaveOp.resolve();
            this.KWFService?.WFInstance?.RevertItem(true);
        });
        const InfStartSaveAnnotations = fn.once(() => {
            this.EnqueueOperation(() => FirstAnnotSaveOp.promise);
            this.$c.timeout(5000).then(FirstAnnotSaveOp.resolve) // ... safe fail

        });
        const UnWRfSave = () => $(document)
            .off("RWFAnnotationsSaved", RWFAnnotationsSaved)
            .off("InfStartSaveAnnotations", InfStartSaveAnnotations);
        $(document).on("RWFAnnotationsSaved", RWFAnnotationsSaved).on("InfStartSaveAnnotations", InfStartSaveAnnotations);
        kBind(this, UnWRfSave, _Events.destroyed);

        // #region : IBAN on Wizard : Filter space when pasting from Clipboard
        if (this.DisplayPageName == this.WizardPagename) {
            $("[navPropertyName=IBAN] .k-input,[navPropertyName=IBAN].k-input", element).each((idx, elem: HTMLInputElement) => {
                var elIban = $(elem),
                    inputIban = <HTMLInputElement>elIban[0];
                elIban.bind("paste.kwf", (e) => {
                    try {
                        var clipboardData = <DataTransfer>(window["clipboardData"] || e["clipboardData"] || (e.originalEvent && e.originalEvent["clipboardData"])),
                            origText = clipboardData.getData('text'),
                            text = origText.replace(/\s+/g, '');
                        if (text != origText) {
                            e.preventDefault();
                            var textAreaTxt = elIban.val();
                            elIban.val(textAreaTxt.substring(0, inputIban.selectionStart) + text + textAreaTxt.substring(inputIban.selectionEnd));
                        }
                    } catch (err) { /* not available in all Browsers */ }
                });
                this.one(_Events.displaychange, () => $(elem).unbind(".kwf"));
            });
        }
        //#endregion
        this.trigger(_Events.rendered, { element: element });

        //#region Custom UI Style for "remaining amount" if <> 0
        const displayItem = this.DisplayItem;
        if (displayItem && displayItem.MetaData.PropsByName["RemainingAmount"]) {
            const elRemaining = $("[navPropertyName=RemainingAmount] .k-input,[navPropertyName=RemainingAmount].k-input", element);
            if (elRemaining.length) {
                const refreshRemaining = () => {
                    const amount = displayItem.GetValue("RemainingAmount");
                    $(elRemaining).toggleClass("idms_Invalid", amount !== 0);
                };
                this.one(_Events.rendered, displayItem.RegisterPropertyChanged("RemainingAmount", refreshRemaining));
                refreshRemaining();
            }
        }
        //#endregion

        this.refreshActions();
    }

    //#region Properties
    /** Unique Identifier (KWF3 : WFInstanceKey /KWF2 : ItemsId) */
    public ID: string;

    /** Wizard Unique Identifier **/
    public WizardGuid: string;

    /** the Property to be Displayed for Current Visualization */
    public DisplayItem: NavPageItem;

    /** Current Item(s) Anchor obj */
    public Anchor: NavItemAnchor;

    /** = Navigateable if Display as Grid desired, undefined otherwise */
    public VisibleNavigatable: NavPropertyItems;

    /** Page Name of the Currently Display NAV Page Item */
    public DisplayPageName: DisplayPage_Main;

    /** Workflow is currently in Wizard State */
    public IsWizard: boolean;

    /** Is FWF */
    public IsFWF: boolean;

    /** Mandant Part for Display */
    public DisplayMandant: string;

    /** z.B. Einkaufsrechnung, Verkaufsrechnung, ... */
    public DisplayTitle: string;

    /** z.B. Firma. Müller - Infoma Rechnungsworkflow */
    public DocumentTitle: string;

    /** ViewConfiguration for the Current Display Item to Display (-> SetCurrentDisplayEntry)*/
    public DisplayView: IViewPageDisplay;

    /** Current "Main" Line Data if Available : Either SubPageItems or TopLevel ReadMultiple Items ("Container") */
    public DisplayMainLineData: NavPropertyItems;

    /** Current Lugm Line Data */
    public DisplayLugMData: NavLineData;

    /** Model for Routing Actions */
    public RoutingActions: IKWFRoutingActions;
    /** Selected Root Action, Do Set Only via Session **/
    public SelectedRootAction: IKWFRoutingAction;
    /** Selected Sub Action, Do Set Only via Session **/
    public SelectedSubAction: IKWFRoutingAction;

    /** Sub Action Title */
    public get SubActionTitle() {
        if (this._SelectedSubActionTitle === undefined) {
            const ReCalculate = () => this._SelectedSubActionTitle = GetCurrentSubActionTitle(this.SelectedRootAction) || "";
            kBind(this, ReCalculate, _Events.change);
            ReCalculate();
        }
        return this._SelectedSubActionTitle;
    }
    _SelectedSubActionTitle = undefined;

    /** Currently Selected + Valid Routing Action (-> SelectRoutingAction)*/
    public ValidatedRoutingAction() { return this.validatedRoutingAction; }
    private validatedRoutingAction: IKWFRoutingAction;

    /** Currently Mandatory Actions info */
    public MandatoryActions: IFDRW_Workflow_Instance_Action_List;

    /** Available Forwarding Comments */
    public AvailableForwardingComments: IKWFComment[] = [];

    /** Selected Forwarding Comment */
    public SelectedForwardingComment: IKWFComment;

    /** Current Remark */
    public CurrentRemark: string;

    /** Operation Info; see constructor for Valid action Names */
    public readonly KWFOperations: { [name: string]: IInfOperation } = {};

    /** Marker : An Async Operation is Currently in Progress */
    public IsInOperation = false;

    /** Marker : Session Is Destroyed */
    public IsDestroyed = false;

    //#endregion

    //#region Operations

    /** Add Notification to be displayed (gets set in Constructor to defer display after Rendering ) */
    public AddNotification: (entry: InfNotificationEntry) => () => void;

    /** Select a Root Routing Action by User Triggered Functionality (from UI)*/
    public SelectRootRoutingAction(action: IKWFRoutingAction) {
        return UISafe(this.EnqueueOperation(() => this.RefreshRoutingAction(action)));
    }

    /** Select a Sub Routing Action by User Triggered Functionality (from UI)*/
    public SelectSubRoutingAction(action: IKWFRoutingAction) {
        if ((!action || !action.ID) && this.validatedRoutingAction) {
            return UISafe(this.RefreshRoutingAction(this.validatedRoutingAction._GroupItem));
        }

        return UISafe(this.EnqueueOperation(() => this.RefreshRoutingAction(action)));
    }

    /** Select Routing Action with imp Validate ... */
    public RefreshRoutingAction(externalAction: IKWFRoutingAction) {
        var info = this.resolveToGroup(externalAction),
            realAction = info.Real || undefined;
        var result = this.$c.when(this.KWFService.OnSelectRoutingAction(realAction)).then(routingInfo => {
            this.AvailableForwardingComments = (routingInfo && routingInfo.ForwardingComments) || [];
            // Reset Forwarding Comment State
            var currCmtId = this.SelectedForwardingComment && this.SelectedForwardingComment.ID;
            if (currCmtId) {
                this.SelectedForwardingComment = fn.FindFirst(this.AvailableForwardingComments, item => item.ID == this.SelectedForwardingComment.ID);
            }
            this.MandatoryActions = routingInfo.MandatoryActions || <any>{};
            [this.SelectedRootAction, this.SelectedSubAction] = [info.Root, info.Sub];
        });
        // Ensure Action Gets Selected only on success
        result.then(
            () => {
                this.validatedRoutingAction = realAction;

                const evRefreshRoutingAction = "RefreshRoutingAction";
                this.trigger(evRefreshRoutingAction);
                var hint = realAction && realAction.WFActionHint;
                if (hint) {
                    this.one(evRefreshRoutingAction, this.AddNotification({ message: hint, messageType: "warning" }));
                }
            },
            err => {
                // Reset Info to Validated Action
                var orig = this.resolveToGroup(this.validatedRoutingAction);
                [this.SelectedRootAction, this.SelectedSubAction] = [orig.Root, orig.Sub];
                throw err;
            })
            .then(() => this.refreshActions());

        return result;
    }

    /** Resolve (External) Action Input to Grouped Internal Information */
    private resolveToGroup(externalAction?: IKWFRoutingAction) {
        if (externalAction && externalAction._Items) {
            // It's a grouping action
            // Keep Related SubAction if in Group
            var rootAction = this.RoutingActions.RootItems.filter(item => item.ID == externalAction.ID)[0];
            var subAction = this.validatedRoutingAction && rootAction && rootAction._Items.filter(item => item.ID == this.validatedRoutingAction.ID)[0] ||
                (rootAction._Items.length == 1 && rootAction._Items[0]); // Select first item by default if only one item in list
            var realAction = subAction;
        }
        else {
            // It's a Real action
            var realAction = externalAction && this.RoutingActions.Items.filter(item => item.ID == externalAction.ID)[0];
            var subAction = realAction && realAction._GroupItem ? realAction : undefined;
            var rootAction = (realAction && realAction._GroupItem) || realAction;
        }

        return {
            Root: rootAction,
            Real: realAction || undefined,
            Sub: subAction || undefined,
        };
    }

    /*** Erfassung Schliessen nach Benutzernachfrage */
    public Close(isZwischenspeichern: boolean) {
        var me = this;
        const deleteClosing = () => delete me["_closingAction"];
        // "_closingAction" : keep track of running Closing action (avoid reentrancy)
        var result = <PromiseLike<void>>this["_closingAction"] || (this["_closingAction"] = this.rejectIfRunning() ||
            (this.withConfirm("Erfassung schliessen?", true).then(
                (e) => me.EnqueueOperation(() => this.KWFService.CloseSession(this, isZwischenspeichern))).then(s => {
                    // Success
                    return me.destroy();
                }, err => {
                    if (fn.error.IsCancel(err)) {
                        return;
                    }

                    return this.ifConfirm("Beim Schliessen des Formulars über die Anwendung ist ein Fehler aufgetreten:\n " +
                        util.errResolve(err) + "\nSoll das Schliessen erzwungen werden?",
                        () => me.destroy(),
                        () => me.KWFService.RevertDisplay());
                })));
        result.then(deleteClosing, deleteClosing);
        return result;
    }

    /** Weiterleiten nach Benutzernachfrage*/
    private Route() {
        return this.rejectIfRunning() ||
            this.withConfirm("Formular wirklich weiterleiten?", true).then(() => this.EnqueueOperation(
                () => this.KWFService.RouteSession(this).then(() => {
                    // Routing Succesfully; "Close" functionality on Backend explicitly triggered;
                    return this.destroy();
                }, err => {
                    if (fn.error.IsExplicit(err))
                        throw err;

                    return this.ifConfirm("Beim Weiterleiten des Formulars ist ein Fehler aufgetreten:\n" +
                        util.errResolve(err) + "\n Soll das Formular trotzdem geschlossen werden?",
                        () => this.destroy(),
                        () => this.KWFService.RevertDisplay());
                })));
    }

    //#region Order Information

    /** Show Order Info Page */
    private ShowOrderInfo(): PromiseLike<IDialogState> {
        try {
            var orderNo = this.getOrderNo();
            if (!orderNo)
                throw new Error("Kein Formular mit Bestellbezug!");

            return this.DialogService.ShowWindow({
                windowOptions: {
                    modal: true,
                    title: "Bestellauskunft für Bestellung '" + orderNo + "'",
                    resizable: true,
                    minWidth: 600,
                    width: Math.max(600, Math.round($(document).innerWidth() * 0.85)) // 85% of doc Width
                },
                controller: CtrlWKFOrderInformation,
                template: CtrlWKFOrderInformation.Template,
                resolve: {
                    "OrderNo": fn.ToFunc(orderNo),
                    "NavUrl": fn.ToFunc(this.DisplayItem.ClientInfo.Url)
                }
            });
        } catch (err) {
            return this.$c.reject(fn.resolveToError(err));
        }
    }
    private getOrderNo() {
        var item = <DisplayPageItem>this.DisplayItem;
        if (!item)
            return;
        switch (item.PageName) {
            case FDDI_DMS_Purchase_Document:
                var orderNo = item.GetValue(PROP_OrderNo);
                break;
            case FDDI_Wizard_Create_New_DMS_Document:
                var orderNo = item.GetValue("Order_No", true);
            default:
            // no orderno!
        }
        return orderNo;
    }

    /** Check Order Overrun: 'true' means is overrun [Ignored if Method not available], Implicit Commit before! (actual  NAV Method Call : true means : isOk) */
    private CheckOrderOverrun() {
        const DisplayItem = <DisplayPageItem>this.DisplayItem,
            $c = this.$c,
            method_CheckOrderOverrun = "CheckOrderOverrun";

        if (!isRechnungMitBestellbezug(DisplayItem))
            return $c.when(false);

        const orderNo = this.getOrderNo();


        return this.NavClient.GetMethodInfo({
            methodName: method_CheckOrderOverrun,
            pageName: DisplayItem.PageName, navUrl: DisplayItem.ClientInfo.Url
        }).then(mInfo => {
            if (!mInfo.Exists)
                return $c.when(false);
            return this.EnsureCommit().then(() => this.EnqueueOperation(() => DisplayItem.ExecuteMethod({
                MethodName: method_CheckOrderOverrun, Parameters:
                {
                    purchHeader: DisplayItem.Key,
                    orderNo: orderNo
                }
            }).then(r => !r["Result"])));
        });
    }

    //#endregion

    private rejectIfRunning() {
        if (this.IsInOperation || (this.Anchor && this.Anchor.InOperation))
            return this.$c.reject("Bitte warten Sie die aktuell laufende Aktion ab!");
    }

    /*** User Confirm as Promise. Caution : Do Not Call inside of "EnqueueOperation" Chain */
    private withConfirm(message: string, noConfirm?: boolean) {
        if (noConfirm)
            return this.$c.when();

        return this.ifConfirm<void>(message, () => undefined, <() => any>(() => { throw __confirmError; }));
    }

    /*** Conditional Promise Resolution after USer Feedback */
    private ifConfirm<T>(message: string, yes: () => PromiseLike<T>, no: () => PromiseLike<T>) {
        return this.DialogService.ShowConfirm({ message: message, title: "RWF" }).then(s => {
            return s ? yes() : no();
        });
    }

    /** teardown instance --> Close visualization (opt. Server Communication must be handled beforeHand) */
    destroy() {
        return UISafe(this.triggerWithDefer(this.$c, _Events.destroy, this.ToEvent({}, this)).then(e => {
            if (!e.isDefaultPrevented()) {
                const IsRunningApp = angular.element(window.document).injector();
                this.IsDestroyed = true;
                // MSQQQ navigation in tests makes no sense/ problems
                if (IsRunningApp) {
                    try {
                        // Close window without confirm
                        window.open('', '_self', '');
                        window.close();
                        // In Case users Cancels Close : Redirect to default page
                        IsRunningApp.get("$location").url("/").replace();
                    } catch (err) {
                        this.IsDestroyed = false;
                        throw err;
                    };
                }
            }
            this.IsDestroyed = true;

            // Force explicit deregistrations on current Display Context
            return this.$c.finally(this.SetCurrentDisplayItem(undefined, null), () => {
                // as long as child gc problems not resolved
                angular.forEach(this.KWFOperations, v => v.Execute = undefined);
                this.triggerEvent(_Events.destroyed); // chrome debugger does not free objects wOut ???
                this.unbind(undefined);
            });
        }));
    }

    /** Set Current Display from Item or Container of Items */
    public SetCurrentDisplayItems(items: NavPageItems | NavPageItem, viewDefinition: IViewPageDisplay) {
        if (items instanceof NavPageItem) {
            return this.SetCurrentDisplayItem(items, viewDefinition);
        }
        var displayItem = items && items.Items[0];
        if (items) {
            items.SetSelected(displayItem);
        }

        return this.SetCurrentDisplayItem(displayItem, viewDefinition);
    }

    /** Trigger Change of Display Entry and associated properties/functionality */
    private SetCurrentDisplayItem(item: NavPageItem, viewDefinition: IViewPageDisplay): PromiseLike<any> {

        const afterTrigger = () => {
            const refreshActions = fn.proxy(this.refreshActions, this),
                service = this.KWFService,
                view = this.DisplayView = viewDefinition || { PageName: "", ViewName: "", Groups: [] },
                viewName = (view && view.ViewName) || "",
                views = view.Groups;
            let viewPersistToken: string;
            if (!this.CurrentState.LugmEnabled) {
                views.forEach(view => view.Properties = view.Properties.filter(item => item.Name != PROP_LuGMAddRec));
            }
            SyncLeistungsDatumVisibilityFromSetting(item?.PageName, service.WFSettings.IsLeistungsdatumActive, views)

            view.Groups = views.filter(item => item.Properties.length > 0);
            const previousPageName = this.DisplayPageName;

            if (this.DisplayItem !== item) {
                this.DisplayItem = item;
                let anchor = this.Anchor = item && item.Anchor;
                this.DisplayMainLineData = this.DisplayLugMData = this.VisibleNavigatable = null;
                this.DisplayPageName = undefined;
                // Excute actions collected in previous cycle
                var register = this.displayItemChangeActions;
                fn.combine(register.splice(0))();

                if (item) {
                    let newPageName = <DisplayPage_Main>item.PageName;
                    if (item.PageName == FDRW_Anordnungsblatt) {
                        let kamwzrdItem = service.WizardItem;
                        let getShowEinnahmeAusgabe = () => ("" + kamwzrdItem.GetValueEx("EinnahmeAusgabe")).indexOf("PK") >= 0;
                        item.RegisterDependency([{
                            DestProperties: ["Abgabenart"], // Sichtbar wenn auf PK endet
                            Visible: getShowEinnahmeAusgabe,
                            Enabled: () => (getShowEinnahmeAusgabe() ? null : false)
                        }], this);

                        let Isclearing = kamwzrdItem.GetValueEx("EinnahmeAusgabe") == "Clearing";
                        if (Isclearing) {
                            // Unfortunately we must do it this way as info not available no item itself ...
                            // Remove Constraint on "Einnahme:_Augabe"
                            register.push(kBind(this.NavClient, (s: IDetermineDynamicLookupEvent) => {
                                let Constraints = s && s.LookupInfo && s.LookupInfo.Constraints;
                                let SourcePageName = s && s.DetermineLookup && s.DetermineLookup.PageName;
                                let TargetPageName = s && s.LookupInfo && s.LookupInfo.TargetPageName;
                                if (Constraints && SourcePageName == FDRW_Anordnungsblatt && TargetPageName === "FDDI_Haushaltsstelle_Übersicht") {
                                    s.LookupInfo.Constraints = fn.clone(Constraints).filter(item => item.FieldName !== "Einnahme_Ausgabe");
                                }
                            }, "AfterGetLookupInfo"));
                        }
                    }
                    // Register Dependencies, Apply Custom info
                    let info: ICustomPropertyDependency = _PropertyDependencies[item.PageName];
                    if (info) {
                        if (info.Dependencies) {
                            item.RegisterDependency(info.Dependencies, this);
                        }

                        if (info.CustomReadonly)
                            register.push(anchor.Readonly.RegisterPerItemResolution(info.CustomReadonly));

                        if (info.CustomMandatory)
                            register.push(anchor.Mandatory.RegisterPerItemResolution(info.CustomMandatory));
                    }

                    this.DisplayPageName = newPageName;
                    viewPersistToken = newPageName + (viewName ? "_" + viewName : "") + (service.IsKameral ? "_KAM" : "");

                    register.push(anchor.RegisterPropertyChanged("*", refreshActions));
                    register.push(anchor.RegisterUpdateStateChanged(refreshActions));
                    // 'Currency Precision: loosen Base restriction on Precision'
                    register.push(kBind(item.Root.Anchor, (e: IEvent & { Answer?: boolean | PromiseLike<boolean>; Item: NavPropertyItem, Prop: IPageProperty, Value: number }) => {
                        e.Answer = IsKameral(this.$rwf.RwfSetup)
                            ? this.$c.reject(`Die Erfassung von '${e.Prop.Title}' mit mehr als 2 Nachkomastellen ist kameral nicht möglich!`)
                            : this.DialogService.ShowConfirm(`Wollen Sie für '${e.Prop.Title}' wirklich einen Betrag mit mehr als 2 Nachkommastellen erfassen (${e.Value})?`).then(answer => {
                                if (!answer)
                                    fn.error.ThrowCancel();
                                return answer;
                            });
                    }, "OnExceedCurrencyValuePrecision"));

                    var clientInfo = item.ClientInfo;
                    let lineProp: string, lineMain: NavPropertyItems;
                    if (lineProp = clientInfo.MasterLineProperty) {
                        lineMain = item.GetLineData(lineProp);
                        if (lineMain && lineMain.Items.length > 0 && lineMain.SelectionCount == 0) {
                            lineMain.SetSelected(lineMain.Items[0]);
                        }
                    } else {
                        lineMain = item.Container;
                    }
                    if (this.DisplayMainLineData = lineMain) {
                        register.push(lineMain.RegisterSelectionChanged(refreshActions));
                    }
                    var container = item.Container;
                    // So far visible Navigation : on Kameral Scenario only (Either on Root Items [ReadMultiple, FDRW_Anordnungsblatt etc.] or 'Nain Items' (FDRW_Auftrag)
                    this.VisibleNavigatable = service.IsKameral && (container || lineMain);
                    if (container) {
                        if (container.SelectedIds.indexOf(item.ClientKey) < 0)
                            container.SetSelected(item.ClientKey);
                        // Reflect current selected item to visualization
                        register.push(container.RegisterSelectionChanged(() => {
                            var displayItem = this.DisplayItem;
                            if (displayItem && container == displayItem.Container && (container.SelectedIds.indexOf(displayItem.ClientKey) < 0 || container.SelectedIds.length == 0)) {

                                var nextid = container.SelectedIds[0];
                                if (nextid) {
                                    var nextItem = nextid && <NavPageItem>container.GetItems(nextid)[0];
                                    this.SetCurrentDisplayItem(nextItem, view);
                                } else if (container.Count > 0) {
                                    container.SetSelected(container.Items[0]);
                                } else if (displayItem.IsDeletedInNav) {
                                    this.setCurrentDisplayItem(undefined); // reset Item display on Deletion
                                }
                            } else if (container && container.SelectedIds.length > 1) {
                                this.setCurrentDisplayItem(undefined); // reset Item display on multiSelection
                            }
                        }));
                    }

                    var lineLugm = this.CurrentState.LugmEnabled && item.MetaData.PropsByName[PROP_LuGMAddRec] ? item.GetLineData(PROP_LuGMAddRec) : null;
                    if (lineLugm && this.$rwf.RwfUser.IsLuGMUser === false) {
                        // Make Lugm Data readonly if no lugm user
                        item.Anchor.Readonly.ReplaceValues("NoLugmUser", [PROP_LuGMAddRec]);

                        if (lineLugm.Count == 0) {
                            // Do Not Show Lugm if no data + no lugm user!
                            lineLugm = undefined;
                            views.forEach(view => view.Properties = view.Properties.filter(item => item.Name != PROP_LuGMAddRec));
                            view.Groups = views.filter(item => item.Properties.length > 0);
                        }
                    }
                    if (lineLugm) {
                        this.DisplayLugMData = lineLugm;
                        register.push(lineLugm.RegisterSelectionChanged(refreshActions));
                    }
                } else {
                    // No Current Item
                    if (service.SourceRecordInfos) {
                        // it's an FWF
                        viewPersistToken = "FWF" + (viewName ? "_" + viewName : "") + (service.IsKameral ? "_KAM" : "");
                    } else {
                        delete view.UserPersistToken;
                    }
                }
            }

            this.IsWizard = this.DisplayPageName == service.WizardPagename;
            this.IsFWF = !item && !!this.KWFService?.WFInstance?.Model.SourceRecord;
            if (view) {
                view.UserPersistToken = (viewPersistToken && ["KWF", "ViewConfiguration", viewPersistToken]);
            }
            this.RefreshState();

            this.setCurrentDisplayItem(this.DisplayItem);
            if (this.DisplayPageName !== previousPageName) {
                this.trigger(SessionEvents.displaypagechange);
            }

            // this only ensures that applying of user Settings (for Grid Rows etc)
            // is done on settings and not on already instantiated instance, which would be a performance issue
            // (on Created Instance changing col info would recreate the grid UI)
            return view && view.UserPersistToken &&
                this.NavSettings.CreateUserSettings(view.UserPersistToken).ForceLoaded().then(fn.noop, fn.nullOp);
        };

        return this.triggerWithDefer(this.$c, _Events.applycurrentfieldinfo, { DisplayItem: item })
            .then(afterTrigger, afterTrigger);
    }

    private setCurrentDisplayItem(item: NavPageItem) {
        // Trigger displayChange : Properties must match INavPageItemEditorOptions
        this.trigger(_Events.displaychange, <INavPageItemEditOptions>{
            Item: item,
            View: this.DisplayView,
            Register: this.RegisterDisplayChange,
            Rendered: this.Rendered
        });

        this.displayItemChanged();
    }

    /** Actions to be called upon next Item Change */
    private displayItemChangeActions = new Array<() => void>();

    /** Handle internal functionality after Current Display Item is changed */
    private displayItemChanged() {
        var $c = this.$c,
            navClient = this.NavClient,
            DisplayItem = this.DisplayItem,
            GetValue = DisplayItem && fn.proxy(DisplayItem.GetValue, DisplayItem);

        //#region calculate DocumentTitle

        // Calculate/Set Page Title
        var docTitle = this.IsFWF ? "Axians Infoma Workflow" : "Axians Infoma Rechnungsworkflow";
        try {
            switch (this.DisplayPageName) {
                case FDDI_Wizard_Create_New_DMS_Document:
                case FDRW_Wizard:
                    docTitle = "Neuer Beleg - Axians Infoma Rechnungsworkflow";
                    break;
                case FDDI_DMS_Purchase_Document:
                    docTitle = [GetValue("Buy_from_Vendor_Name"), GetValue("Buy_from_Vendor_Name_2"), " - ", docTitle].join("");
                    break;
                case FDDI_DMS_Sales_Document:
                    docTitle = [GetValue("Sell_to_Customer_Name"), GetValue("Sell_to_Customer_Name_2"), " - ", docTitle].join("");
                    break;
                case FDRW_Anordnungsblatt:
                    docTitle = [GetValue("Name"), GetValue("Name_2"), GetValue("Name_3"), "-", docTitle].join(" ");
                    break;
                case FDRW_Auftragsbuchblatt:
                case FDRW_Auftrag:
                    // use default ?
                    break;
                default:
                    fn.never(this.DisplayPageName);
            }
        } catch (err) { }
        this.DocumentTitle = docTitle;

        //#endregion

        //#region Set Up CheckOrder Interceptor Logic: ("displaychange" -> implicit deregistration!)
        // Enforce Validation of OrderInfo, Inform user if is not valid
        if (this.DisplayPageName == FDDI_DMS_Purchase_Document && isRechnungMitBestellbezug(DisplayItem)) {
            /** Marker */
            var validateOrderNecessary = true;

            // Validate Order Information when Window is Shown
            this.bind(_Events.displaychange, this.bindWithDefer(() => { validateOrderNecessary = false; }, "ShowOrder"));
            // Invalidate Order Information when Value is Changed
            var checkProp = this.DisplayItem.ClientInfo.AllProperties[PROP_SumLines];
            this.bind(_Events.displaychange, this.Anchor.RegisterPropertyChanged(checkProp, () => validateOrderNecessary = true));
            /** Intercept "Route" Action : validate Order Information if Necessary  */
            this.bind(_Events.displaychange, this.bindWithDefer(() => {
                if (!validateOrderNecessary)
                    return $c.when(); // Validation has already be done
                if (this.validatedRoutingAction && this.validatedRoutingAction._IsBackAction == true)
                    return $c.when(); // Routing is 'back'

                return this.CheckOrderOverrun().then(isOverrun => {
                    if (!isOverrun) {
                        validateOrderNecessary = false;
                        return $c.when(); // OrderInfo is valid
                    }

                    // Ask User what to do with
                    return this.DialogService.ShowQuestion({
                        message: "Der Restbetrag für Bestellzeile(n) ist überschritten! Was möchten Sie tun?", title: "Bestellung", answers: [
                            { caption: "Aktion trotzdem ausführen", result: 0 },
                            { caption: "Bestellung anzeigen", result: 1 },
                            { caption: "Abbrechen", result: 2, default: true },
                        ]
                    }).then(answer => {
                        switch (answer) {
                            case 0: // Trotzdem buchen
                                validateOrderNecessary = false;
                                return;

                            case 1: // Bestellung anzeigen
                                return this.ShowOrderInfo().then((info) => info.close.then(() => {
                                    validateOrderNecessary = false;
                                    throw __confirmError;
                                }));

                            case 2: // Abbruch
                                throw __confirmError;

                            default:
                                throw new Error("Unerwartete Antwort: " + answer);
                        }
                    });
                });
            }, "Route", "Sign"));
        }
        //#endregion

        //#region Set Up Sync of  Main/LugmLine
        let counter = CreateCounter(this),
            DisplayMainLineData = this.DisplayMainLineData,
            DisplayLugMData = this.DisplayLugMData;
        if (DisplayMainLineData)
            this.one(_Events.displaychange, DisplayMainLineData.RegisterSelectionChanged(() => {
                if (counter.IsRunning())
                    return;
                counter.Wrap(() => this.trigger(_Events.MainLineSelectionChanged));
            }));
        if (DisplayLugMData)
            this.one(_Events.displaychange, DisplayLugMData.RegisterSelectionChanged(() => {
                if (counter.IsRunning())
                    return;
                counter.Wrap(() => this.trigger(_Events.LuGMLineSelectionChanged));
            }));
        //#endregion
    }
    //#endregion

    /** Execute Posting Check, Caution: Prerequisist right now: CurrPage in [], Meth Available ... */
    private ExecutePostingCheck(config: {
        /** Optional Grid Displaying Main Line Data  */
        readonly mainGrid?: INavGrid,
        readonly supressSucessError?: true
    }) {
        const DisplayMainLineData = this.DisplayMainLineData;
        const WFInstance = this.KWFService.WFInstance;
        const Event_PostingCheck = "PostingCheck";

        WFInstance.Model.trigger(Event_PostingCheck);
        return ExecutePostingCheck({
            $c: this.$c,
            WFInstance: WFInstance,
            DisplayMainLineData: DisplayMainLineData,
            supressSucessError : config?.supressSucessError,
            onErr: check => {
                // Highlight Matching Lines
                if (config.mainGrid && DisplayMainLineData.Count > 1) {
                    const colTemplate = (dataItem) => {
                        const m = fn.FindFirst(check, c => c.Item?.Model === dataItem);
                        const htmlErr = (m && m.Error && htmlEncode(m.Error)) || "";
                        return htmlErr && (`<div class='idms_truncate' title='${htmlErr}' ><span class='idms_Image idms_Image_Error' ></span>&nbsp;${htmlErr}</div>`);
                    };
                    // Prepend Column with Per Line Warnings
                    config.mainGrid.reCreate(o => o.columns.splice(0, 0, {
                        template: colTemplate, title: "Belegprüfung", filterable: false, menu: false, width: "36px"
                    }));

                    // Remove Column before next check
                    WFInstance.Model.one(Event_PostingCheck, () => {
                        if (config.mainGrid) {
                            config.mainGrid.reCreate((o) => {
                                const columns = o.columns;
                                const toRemove = columns.filter(item => item.template === colTemplate);
                                toRemove.forEach(t => columns.splice(columns.indexOf(t), 1));
                            });
                        }
                    });
                }
            }
        }).then(fn.identity, err => {
            const errMessage = fn.resolveToError(err);
            if (fn.error.IsCancel(err) || errMessage == this.CurrentRemark) {
                throw err;
            }
            return this.DialogService.ShowQuestion({
                message: errMessage,
                answers: [
                    {
                        caption: "OK, als Bemerkung übernehmen",
                        result: true,
                    }, {
                        caption: "Abbrechen",
                        result: false
                    }
                ]

            }).then((r) => {
                if (r == true) {
                    this.CurrentRemark = errMessage
                }
                fn.error.ThrowCancel();
            });
        });
    }

    /** Recalculate State of registered Actions */
    private refreshActions() { this.trigger(_Events.change); }

    /** Refresh State */
    RefreshState(state?: IKWFSessionState) {

        $.extend(this.CurrentState, state || {});
        const doRefresh = () => {
            this.validateState();
            this.refreshActions();
        };
        doRefresh();
        return this.triggerWithDefer(this.$c, _Events.RefreshState).then(doRefresh, doRefresh);
    }

    /** (Re-) Validate State on possible Change of State and/or DisplayItem */
    private validateState() {
        if (!this.Anchor || !this.CurrentState)
            return;

        this.Anchor.Readonly.SetForceAll(!!this.CurrentState.NoEditContent || !!this.CustomState.NoEditContent);
    }

    /** Current State Information */
    public readonly CurrentState = <IKWFSessionState>{
        /** Client Side */
        NoEditContent: false,
        NoChangeDisplay: false,
        NoRouting: false,
        SignatureEnabled: false,
        DocLink: ""
    };

    /** TODO : Unify External State injection (WOut Explizit other Props, Selective Reset of a disabled state will not work ... */
    public CustomState = {
        NoEditContent: false,
        NoChangeDisplay: false,
        NoRouting: false
    };

    /** Start Operation after Currently Running Operations finshed, CAUTION: DO NOT NEST!  */
    public EnqueueOperation<T>(resolvePromise: () => PromiseLike<T>): PromiseLike<T> {
        var $c = this.$c;

        var currResolveAction = () => {
            try {
                if (this.triggerEvent("ExecuteOperation").isDefaultPrevented()) {
                    throw __confirmError;
                } else {
                    // Dispatch to items Operation Queue --> Visual Notification on Items Dependen Visualization
                    if (this.Anchor)
                        var innerResult = <PromiseLike<T>>this.Anchor.EnqueueOperation(resolvePromise.bind(this));
                    else
                        var innerResult = <PromiseLike<T>>UISafe(<PromiseLike<T>>resolvePromise.apply(this));
                }
            } catch (err) {
                innerResult = innerResult || $c.reject(err);
            }

            $c.finally(innerResult, () => {
                this.IsInOperation = (--this.currOpCounter > 0);
                if (this.currOpCounter == 0) {
                    this.refreshActions();
                    this.currOp = null; // necessary? (to be sure, garbage collection ...??)
                }
            });

            this.IsInOperation = (++this.currOpCounter > 0);

            return innerResult;
        };

        var result = this.currOp = (this.currOp || $c.when()).then(currResolveAction, err => currResolveAction());

        this.IsInOperation = true;

        return result;
    }
    private currOpCounter = 0; // necessary?
    private currOp: PromiseLike<any>;

    /** ensure Commit if Not Forced Readonly (if outstanding Changes exist) */
    public EnsureCommit() {
        const $c = this.$c;
        return this.$c.when({}).then(() => {
            if (this.CurrentState.NoEditContent || this.CustomState.NoEditContent || !this.DisplayItem)
                return;
            var displayItem = this.DisplayItem,
                anchor = displayItem.Anchor;
            if (anchor.InOperation) {
                var hasConfirms = false;
                var r = anchor.RegisterUpdateStateChanged(c => {
                    r();
                    hasConfirms = c.Messages;
                });
                return anchor.AfterOperations().then(() => {
                    if (hasConfirms) {
                        throw new Error("Ausstehende Änderungen wurden gespeichert, bitte starten Sie die Aktion erneut.");
                        //return this.NavClient.DialogService.WhenConfirm("Ausstehende Änderungen wurden gespeichert, soll die Aktion fortgeführt werden?");
                    }

                    if (this.DisplayItem.IsInSync)
                        return $c.when<any>({});

                    return this.DisplayItem.Update();

                });
            }
            if (displayItem.IsInSync)
                return $c.when<any>({});

            return displayItem.Update();
        });
    }

    /** Intercept any Closing Action (And cancel by Rejecting returned Promise */
    public BindOnClose(resolvePromise: () => (PromiseLike<any> | void)) {
        return this.bindWithDefer(resolvePromise, "Close", "SaveTemp", "Sign", "Route");
    }

    /** Register Defer Action interceptor */
    bindWithDefer(resolvePromise: (eOuter?: any) => (PromiseLike<any> | void), ...names: string[]) {
        var bindAction = (e) => e.EnqueueDefer(resolvePromise.bind(e));
        names.forEach(name => this.bind(name, bindAction));
        return () => { names.forEach(name => this.unbind(name, bindAction)); };
    }
}

/** setup Customtextselection functionality (see Pdftron Webviewer: ) */
function SetupCustomTextSelection(this: KWFFormSession) {
    var _currEl: JQuery;
    const evid = "focusin." + fn.id();
    var lastProp: string;
    var setCurrEl = (el: JQuery) => {
        if (_currEl) {
            _currEl.off(evid);
        }
        return _currEl = el;
    };
    this.one(_Events.destroyed, () => setCurrEl(undefined));
    this.bind(_Events.rendered, (e: { element: JQuery }) => {
        lastProp = undefined;
        setCurrEl(e.element).on(evid, (ev: JQueryEventObject) => {
            const fld = $(ev.target).closest("[navPropertyName]");
            const checkProp = fld.attr("navPropertyName");
            if (checkProp) {
                lastProp = checkProp
                const rt = fld.parent().closest("[navPropertyName]").attr("navPropertyName")
                if (rt) {
                    lastProp = rt + "." + checkProp;
                }
            }
            // console.log("focusin:" + lastProp);
        });
    });
    $(window).on("CustomTextSelection", (s, e) => {
        // console.log("CustomTextSelection:LastProp=" + lastProp + ",Value:" + e.Text);
        var target: NavPropertyItem = this.DisplayItem;
        if (lastProp && lastProp.indexOf(".") > 0 && this.DisplayMainLineData?.SelectedIds?.length == 1) {
            target = this.DisplayMainLineData.SelectedItems[0];
        }
        if (lastProp && target) {
            // console.log(`Set Value "${lastProp}" to "${e.Text}"`)
            target.SetValue(lastProp, e.Text).then(fn.noop, err => this.DialogService.ShowError(err));
        }
    });
    $(window).on("CustomTextSelectionQuery", (s, e) => { e.Result = lastProp && !this.NoEdit; });
}

/** Force Visibility of 'Leistungsdatum' to be in sync with corrsponding setting (PurchDoc only) */
function SyncLeistungsDatumVisibilityFromSetting(this: void, PageName: string, IsLeistungsdatumActive: boolean, views: IViewPropertyGroup[]) {
    if (PageName !== FDDI_DMS_Purchase_Document || !(views?.length > 0)) {
        return;
    }

    const LDate = "LDate";
    const PDate = "PDate"
    const Leistungsdatum = "Leistungsdatum";
    const Posting_Date = "Posting_Date"
    const allProps: Partial<Record<keyof IFDDI_DMS_Purchase_Document, IViewProperty>> = {};
    let vGroupPostingDate: IViewPropertyGroup
    views.forEach(view => view.Properties.forEach(p => vGroupPostingDate = (((allProps[p.Name] = p).Name == Posting_Date) && view) || vGroupPostingDate));
    const existsHeadLeistungsdatum = allProps[Leistungsdatum];

    const purchDetails = allProps["PurchLines"]?.Details || [];
    const lineProps : Record<keyof IIAX_DMSPurch_DocumentLine, IViewProperty> = fn.ToDictionary(purchDetails, "Name");
    // Leistungsdatum iif IsLeistungsdatumActive
    if (IsLeistungsdatumActive) {
        // Force Availability
        if (!lineProps[LDate]) {
            purchDetails.splice(purchDetails.indexOf(lineProps[PDate]), 0, { Name: LDate })
        }
        if (!existsHeadLeistungsdatum && vGroupPostingDate) {
            vGroupPostingDate.Properties.splice(vGroupPostingDate.Properties.indexOf(allProps[Posting_Date]) + 1, 0, { Name: Leistungsdatum })
        }

    } else {
        // Remove LDate
        views.forEach(g => g.Properties.forEach((v, idx) => {
            if (v.Name == Leistungsdatum) {
                g.Properties.splice(idx, 1);
            }
        }));
        // Force No Availability
        if (lineProps[LDate]) {
            purchDetails.forEach((v, idx) => {
                if (v.Name == LDate) {
                    purchDetails.splice(idx, 1);
                }
            });
        }
    }
}

angular.module("KWF.EditForm", ["KWF.Services", "infoma.navkendo", "infoma.nav"])
    .directive("rwf3PurchOrder", CtrlPurchOrder.Directive)
    .directive("rwf3WizardItem", CtrlWizardItem.Directive)
    .directive("rwf3DeferralSchedule", CtrlDeferralSchedule.Directive)
    .directive("rwf3Huelaufteilung", CtrlHuelaufteilung.Directive)
    .directive("rwf3Kontierungsvorschlag", CtrlKontierungsVorschlag.Directive)
    .directive("rwf3Supplementdocuments", CtrlKWF3SupplementDocuments.Directive)
    .controller("CtrlWKFOrderInformation", CtrlWKFOrderInformation)
    ;
